import * as angular from "angular";
import {IController, IQService, ITimeoutService, IWindowService} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {DataSet} from "vis-data";
import {TasksService} from "../../../tasks/services/tasks-service.service";
import {ResourcesAlertsService} from "../../../resources/services/resources-alerts.service";
import {BringozTimelineService} from "../../../commons/services/bringoz-timeline-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {TaskModel} from "../../../tasks/models/task.model";
import {LeanPlanningAlertsService} from "../../../lean-planning/services/lean-planning-alerts.factory";
import {LeanPlanningService} from "../../../lean-planning/services/lean-planning-service.service";
import {TasksDialogService} from "../../../tasks/services/tasks-dialog.service";
import {VisitScheduleResourceModel} from "../../models/visit-schedule-resource.model";
import {PlanningCommonService} from "../../../planning/services/planning-coomon-service.service";
import {VisitScheduleDayModel} from "../../models/visit-schedule-day.model";
import {
  isVisitScheduleDayDispatched,
  isVisitScheduleDayDispatchedById
} from "../../models/visit-schedule-day.functions";
import {PlanningAlertsService} from "../../../planning/services/planning-alerts.service";
import {PlanningDialogService} from "../../../planning/services/planning-dialogs-service.service";
import {VisitPlanModel} from "../../models/visit-plan.model";
import * as moment from "moment/moment";
import {
  VisitScheduleAnalysisModel, VisitScheduleResourceAnalysisModel,
  VisitScheduleResourceAnalysisRisksDataModel, VisitScheduleResourceHolderAnalysisModel,
  VisitScheduleRouteActivityAnalysisModel, VisitScheduleRouteAnalysisModel
} from "../../models/visit-schedule-analysis.model";
import {VisitScheduleRouteActivityRiskEnum} from "../../enums/visit-schedule-route-activity-risk.enum";
import {SchedulingProjectAlertsService} from "../../services/scheduling-project-alerts.service";
import {VisitScheduleActivityDetailsModel} from "../../models/visit-plan-route.model";
import {VisitScheduleResourceHolderExt} from "../../models/visit-schedule-resource-holder-ext.model";
import {escapeHtml} from "../../../commons/utils/html-escape.util";

export class VisitScheduleTimelineComponent implements IController {

  visitPlan: VisitPlanModel;
  page: number;
  size: number;
  totalElements: number;
  agents: VisitScheduleResourceHolderExt[];
  resourcesUtilization: any;
  resources: VisitScheduleResourceModel[];
  routes: any;
  tasks: TaskModel[];
  analysis?: VisitScheduleAnalysisModel;
  range: any;

  agentColorMap: any;
  jobs: any[];
  programTypeAliasMap: { [key: string]: string };
  isHidden?: boolean;
  visitScheduleDays: VisitScheduleDayModel[];
  onPaginationChange: Function;
  onToggleMap: Function;
  onDispatchDay: Function;
  onMoveItem: Function;
  onJobRightClick: Function;
  onInspectRouteClick: Function;
  onConflictIconClick: Function;

  private container: any;
  private vis: any;
  private rrule: any;
  private options: any;
  private timeline: any;
  private tableHeaderDivRef: any;
  private groupsDataSet: any;
  private readonly timeFormat: any;
  private readonly shortDateFormat: any;
  private readonly longDateFormat: any;
  private timeZone: any;
  private purposeToSkillMap: any;
  private serviceFinishStatuses: string[];
  private itemsDataSet: any;
  private isExpandedRoutes: any;
  private colorPallet: any;


  ////////////////////////////// ICONS //////////////////////////////
  private iconsUrl: any;
  private $agentTypeIcon: any;
  private $emptyStarIcon: any;
  private $fullStarIcon: any;
  private readonly $branchIcon: any;
  private readonly $serviceAreaIcon: any;
  private readonly $employmentTypeIcon: any;
  private readonly $skillsIcon: any;
  private $recurringIcon: any;
  private $resourceIcon: any;
  private $priorityIcon: any;
  private $routedRowIcon: any;
  private $routedWhiteIcon: any;
  private $depotIcon: any;
  private $locationIcon: any;
  private $tripIcon: any;
  private $accountIcon: any;
  private $originalTimeWindowIcon: any;
  private $timeWindowIcon: any;
  private $serviceTimeIcon: any;
  private $programIcon: any;
  private $packageIcon: any;
  private $spotsIcon: any;
  private $weightIcon: any;
  private $volumeIcon: any;
  private $mapIcon: any;
  public $timeZoneIcon: any;
  public $riskIcon: any;

  public groupsViewSettings: any = {
    tags: true
  };
  public siteSkills: any;
  public $infinitySymbol: string;
  private isFirstFit: boolean;
  public jobsMap: any;
  public movingItem: any;
  public userZoneId: string;
  public timezoneOffset: number;
  public isSingleDay: boolean;

  private isDrawing: boolean = false;

  // Per-cell tooltip dismiss closures; a single window scroll/resize listener
  // (registered once in $onInit) iterates this list so we don't add a new pair
  // of window listeners for every group template render.
  private _activeTooltipHides: Array<() => void> = [];
  private _windowHideTooltips = () => {
    if (!this._activeTooltipHides.length) return;
    this._activeTooltipHides.slice().forEach((fn) => fn());
  };

  // Single delegated click handler for group-row actions, attached once on
  // `this.container` after the timeline is created. Replaces the per-cell
  // `addEventListener` on the agent name link inside `groupTemplate`. (Tooltip
  // mouseenter/mouseleave handlers on totalsContainer are intentionally left
  // per-cell because they don't bubble; their leak surface was already
  // neutralized by the shared window-listener fix above.)
  private readonly _onContainerClick = (event: Event) => {
    const target = event.target as Element | null;
    if (!target) return;
    const actionEl = target.closest('[data-bz-action]') as HTMLElement | null;
    if (!actionEl) return;
    const action = actionEl.dataset.bzAction;
    const id = actionEl.dataset.bzId;
    if (!action || !id) return;
    this._onClicked().then(() => {
      if (action === 'view-agent-schedule') {
        const siteId = this.splitService.getSiteId();
        const url = this.$state.href('agent.agent-profile.schedule', {id: id, siteId: siteId});
        this.$window.open(url, '_blank');
      }
      if (action === 'open-availability-conflicts') {
        this.onConflictIconClick();
      }
    });
  };


  constructor(private $q: IQService, private confirmDialogService: ConfirmDialogService, private $filter, private splitService: SplitService, private commonsService: CommonsService,
              private leanPlanningConstants, private resourcesAlertsService: ResourcesAlertsService, private leanPlanningAlertsService: LeanPlanningAlertsService,
              private commonsDialogService: CommonsDialogService, private moment, private $timeout: ITimeoutService, private bringozTimelineService: BringozTimelineService,
              private $log, private tasksService: TasksService, private commonsConstants, private deliveriesConstants, private $state, private $window: IWindowService,
              private leanPlanningService: LeanPlanningService, private tasksDialogService: TasksDialogService, private planningDialogService: PlanningDialogService, private schedulingProjectAlertsService: SchedulingProjectAlertsService,
              private planningCommonService: PlanningCommonService, private $compile, private $scope, private planningAlertsService: PlanningAlertsService) {

    this.$infinitySymbol = '&#8734;';
    this.vis = require('vis-timeline');
    this.rrule = require('rrule');

    const dateAndTimeConfig = splitService.getDateAndTimeConfig();
    this.timeFormat = dateAndTimeConfig.time;
    this.shortDateFormat = dateAndTimeConfig.date;
    this.longDateFormat = dateAndTimeConfig.long;
    this.timeZone = splitService.getTimeZone();
    this.siteSkills = splitService.getSiteResourceSkills();

    this.purposeToSkillMap = {
      Pickup: ['Delivery'],
      Dropoff: ['Delivery'],
      Operation: ['Merchandise', 'Order']
    };
    this.serviceFinishStatuses = this.deliveriesConstants.serviceFinishStatuses;


    this.iconsUrl = {
      account: 'assets/images/icons/v2/account.svg',
      emptyStar: 'assets/images/icons/v2/skill-outline.svg',
      fullStar: 'assets/images/icons/v2/skill.svg',
      agentType: 'assets/images/icons/v2/agent.svg',
      branch: 'assets/images/icons/v2/branch.svg',
      serviceArea: 'assets/images/icons/v2/service-area.svg',
      employmentType: 'assets/images/icons/v2/dollar-circle.svg',
      skill: 'assets/images/icons/v2/skill.svg',
      recurring: 'assets/images/icons/v2/recurring.svg',
      resource: 'assets/images/icons/v2/tiles-outline.svg',
      routed: 'assets/images/icons/v2/route.svg',
      program: 'assets/images/icons/v2/program.svg',
      risk: 'assets/images/icons/v2/risk.svg',
      Bicycle: 'assets/images/icons/v2/bicycle.svg',
      Motorcycle: 'assets/images/icons/v2/motorcycle.svg',
      PrivateCar: 'assets/images/icons/v2/privatecar.svg',
      Van: 'assets/images/icons/v2/van.svg',
      Truck: 'assets/images/icons/v2/truck.svg',
      Forklift: 'assets/images/icons/v2/forklift.svg',
      Trailer: 'assets/images/icons/v2/trailer.svg',
      Tractor: 'assets/images/icons/v2/tractor.svg',
      ElectricCar: 'assets/images/icons/v2/electriccar.svg',
      ElectricTruck: 'assets/images/icons/v2/electrictruck.svg',
      ElectricVan: 'assets/images/icons/v2/electricvan.svg',
      map: 'assets/images/icons/v2/map.svg',
      address: 'assets/images/icons/v2/location-pin.svg',
      weight: 'assets/images/icons/v2/weight.svg',
      volume: 'assets/images/icons/v2/volume.svg',
      originalTimeWindow: 'assets/images/icons/v2/calendar-outline.svg',
      timeWindow: 'assets/images/icons/v2/time-window-outline.svg',
      barcode: 'assets/images/icons/v2/barcode.svg',
      serviceTime: 'assets/images/icons/v2/timer-outline.svg',
      relation: 'assets/images/icons/v2/relation.svg',
      packageItem: 'assets/images/icons/v2/package-outline.svg',
      spot: 'assets/images/icons/v2/spot.svg',
      info: 'assets/images/icons/v2/info-outline.svg',
      skills: 'assets/images/icons/v2/skill.svg',
      depot: 'assets/images/icons/v2/depot.svg',
      priority: 'assets/images/icons/v2/priority.svg',
      eye: 'assets/images/icons/v2/show.svg',
      eyeOn: 'assets/images/icons/v2/eye-on.svg',
      eyeOff: 'assets/images/icons/v2/eye-off.svg',
      location: 'assets/images/icons/v2/location-pin-outline.svg',
      link: 'assets/images/icons/v2/linked.svg',
      error: 'assets/images/icons/v2/error-outline.svg',
      menu: 'assets/images/icons/v2/menu.svg',
      locked: 'assets/images/icons/v2/lock.svg',
      unlocked: 'assets/images/icons/v2/lock-open-outline.svg',
      trip: 'assets/images/icons/v2/route.svg',
      timeZone: 'assets/images/icons/v2/time-zone.svg',
    }

    this.$accountIcon = document.createElement('IMG');
    this.$accountIcon.setAttribute("src", this.iconsUrl.account);
    this.$accountIcon.classList.add('bringoz-icon-small', 'gray');

    this.$emptyStarIcon = document.createElement('IMG');
    this.$emptyStarIcon.setAttribute("src", this.iconsUrl.emptyStar);
    this.$emptyStarIcon.classList.add('bringoz-icon-16', 'gray');

    this.$packageIcon = document.createElement('IMG');
    this.$packageIcon.setAttribute("src", this.iconsUrl.packageItem);
    this.$packageIcon.classList.add('bringoz-icon-small', 'gray');

    this.$spotsIcon = document.createElement('IMG');
    this.$spotsIcon.setAttribute("src", this.iconsUrl.spot);
    this.$spotsIcon.classList.add('bringoz-icon-small', 'gray');

    this.$weightIcon = document.createElement('IMG');
    this.$weightIcon.setAttribute("src", this.iconsUrl.weight);
    this.$weightIcon.classList.add('bringoz-icon-small', 'gray');

    this.$volumeIcon = document.createElement('IMG');
    this.$volumeIcon.setAttribute("src", this.iconsUrl.volume);
    this.$volumeIcon.classList.add('bringoz-icon-small', 'gray');

    this.$mapIcon = document.createElement('IMG');
    this.$mapIcon.setAttribute("src", this.iconsUrl.map);
    this.$mapIcon.classList.add('bringoz-icon-small', 'gray');


    this.$fullStarIcon = document.createElement('IMG');
    this.$fullStarIcon.setAttribute("src", this.iconsUrl.fullStar);
    this.$fullStarIcon.classList.add('bringoz-icon-16', 'gray');

    this.$agentTypeIcon = document.createElement('IMG');
    this.$agentTypeIcon.setAttribute("src", this.iconsUrl.agentType);
    this.$agentTypeIcon.classList.add('bringoz-icon-small', 'gray');

    this.$serviceAreaIcon = document.createElement('IMG');
    this.$serviceAreaIcon.setAttribute("src", this.iconsUrl.serviceArea);
    this.$serviceAreaIcon.classList.add('bringoz-icon-small', 'gray');

    this.$branchIcon = document.createElement('IMG');
    this.$branchIcon.setAttribute("src", this.iconsUrl.branch);
    this.$branchIcon.classList.add('bringoz-icon-small', 'gray');

    this.$employmentTypeIcon = document.createElement('IMG');
    this.$employmentTypeIcon.setAttribute("src", this.iconsUrl.employmentType);
    this.$employmentTypeIcon.classList.add('bringoz-icon-small', 'gray');

    this.$originalTimeWindowIcon = document.createElement('IMG');
    this.$originalTimeWindowIcon.setAttribute("src", this.iconsUrl.originalTimeWindow);
    this.$originalTimeWindowIcon.classList.add('bringoz-icon-small', 'gray');

    this.$timeWindowIcon = document.createElement('IMG');
    this.$timeWindowIcon.setAttribute("src", this.iconsUrl.timeWindow);
    this.$timeWindowIcon.classList.add('bringoz-icon-small', 'gray');

    this.$serviceTimeIcon = document.createElement('IMG');
    this.$serviceTimeIcon.setAttribute("src", this.iconsUrl.serviceTime);
    this.$serviceTimeIcon.classList.add('icon', 'bringoz-icon-small');

    this.$programIcon = document.createElement('IMG');
    this.$programIcon.setAttribute("src", this.iconsUrl.program);
    this.$programIcon.classList.add('icon', 'bringoz-icon-small');

    this.$timeZoneIcon = document.createElement('IMG');
    this.$timeZoneIcon.setAttribute("src", this.iconsUrl.timeZone);
    this.$timeZoneIcon.classList.add('bringoz-icon-small', 'gray');

    this.$riskIcon = document.createElement('IMG');
    this.$riskIcon.setAttribute("src", this.iconsUrl.risk);
    this.$riskIcon.classList.add('bringoz-icon-small', 'red');

    this.$skillsIcon = document.createElement('IMG');
    this.$skillsIcon.setAttribute("src", this.iconsUrl.skill);
    this.$skillsIcon.classList.add('bringoz-icon-small', 'gray');

    this.$tripIcon = document.createElement('IMG');
    this.$tripIcon.setAttribute("src", this.iconsUrl.trip);
    this.$tripIcon.classList.add('bringoz-icon-small', 'gray');

    this.$depotIcon = document.createElement('IMG');
    this.$depotIcon.setAttribute("src", this.iconsUrl.depot);
    this.$depotIcon.classList.add('bringoz-icon-small', 'gray');

    this.$locationIcon = document.createElement('IMG');
    this.$locationIcon.setAttribute("src", this.iconsUrl.location);
    this.$locationIcon.classList.add('bringoz-icon-small', 'gray');


    this.$recurringIcon = document.createElement('IMG');
    this.$recurringIcon.setAttribute("src", this.iconsUrl.recurring);
    this.$recurringIcon.classList.add('bringoz-icon-small', 'white');


    this.$priorityIcon = document.createElement('IMG');
    this.$priorityIcon.setAttribute("src", this.iconsUrl.priority);
    this.$priorityIcon.classList.add('bringoz-icon-small');


    this.$routedRowIcon = document.createElement('IMG');
    this.$routedRowIcon.setAttribute("src", this.iconsUrl.routed);
    this.$routedRowIcon.classList.add('bringoz-icon-small', 'gray');


    this.$routedWhiteIcon = document.createElement('IMG');
    this.$routedWhiteIcon.setAttribute("src", this.iconsUrl.routed);
    this.$routedWhiteIcon.classList.add('bringoz-icon-small', 'white');
  }

  $onInit() {

    window.addEventListener("scroll", this._windowHideTooltips, true);
    window.addEventListener("resize", this._windowHideTooltips, true);

    this.userZoneId = this.moment.tz.guess()

    this.timezoneOffset = this.moment.tz.zone(this.userZoneId).utcOffset(this.moment().valueOf()) - this.moment.tz.zone(this.visitPlan.zoneId).utcOffset(this.moment().valueOf());


    this.jobsMap = _.keyBy(this.jobs, (j) => {
      return j.id
    })

    this.colorPallet = this.commonsConstants.colorPalletTwo;

    // create visualization
    this.container = document.getElementById('timeline');

    // Set Timeline
    this.groupsDataSet = new DataSet();
    this.itemsDataSet = new DataSet();

    const numberOfAgents = _.get(this.agents, 'length', 0);

    // Set Options
    this.options = {
      groupOrder: (a, b) => {
        return a.order - b.order;
      },
      groupOrderSwap: (groupDragged, groupToSwap) => {
        const value = groupDragged.order;
        groupDragged.order = groupToSwap.order;
        groupToSwap.order = value;
      },
      onMoveGroup: (groupMoved) => {
        // this.onMoveGroup({agentId: groupMoved.agentId, index: groupMoved.order})
      },
      groupTemplate: (group) => {

        // const routesCount = _.filter(this.routes, (r) => {
        //   return _.get(r, 'agentId') === _.get(group, 'ref.id')
        // }).length;

        if (!group) {
          return null;
        }

        const mainContainer = document.createElement('div');
        mainContainer.classList.add("group-container");

        const groupColor = this.agentColorMap ? this.agentColorMap[group.agentId] : this._getColorByAgentId(group.agentId);
        const colorContainer = document.createElement('div');
        colorContainer.setAttribute('style', `background: ${groupColor}`);
        colorContainer.classList.add("group-color-container");

        // colorContainer.addEventListener("click", (ev) => {
        //   this._onClicked().then(() => {
        //     this.onAgentColorClick({agent: group.ref, color: groupColor})
        //   })
        // }, {passive: true});


        const infoContainer = document.createElement('div');
        infoContainer.classList.add("group-info-container");


        // Agent Name / Skills Row

        // Agent Name
        const nameRow = document.createElement('div');
        nameRow.classList.add("group-info-row");

        const groupNameSpan = document.createElement('a');
        groupNameSpan.classList.add("agent-name", "text-ellipsis", "br-body-2", "font-weight-600");
        groupNameSpan.innerText = group.name;
        if (group.agentId) {
          groupNameSpan.dataset.bzAction = 'view-agent-schedule';
          groupNameSpan.dataset.bzId = String(group.agentId);
        }

        nameRow.insertAdjacentElement('beforeend', groupNameSpan);

        const isExternal = group.isExternal
        if (isExternal) {
          const container = document.createElement('div');
          container.classList.add('imported-container');
          const text = document.createElement('span')
          text.textContent = this.$filter('translate')('Imported');

          container.appendChild(text);
          nameRow.insertAdjacentElement('beforeend', container);
        }

        // const agentStatusDiv = document.createElement('div');
        // agentStatusDiv.classList.add("agent-status", group.status);

        // // Tags
        // if (this.groupsViewSettings.tags && group.tags?.length) {
        //   group.tags.forEach((t) => {
        //     const tag = document.createElement('div');
        //     tag.classList.add('skill-tag');
        //
        //     const skillText = document.createElement('span')
        //     skillText.innerHTML = t;
        //     tag.appendChild(skillText);
        //     nameRow.insertAdjacentElement('beforeend', tag);
        //   })
        // }

        // Tags Row
        let tagsRow;
        if (this.groupsViewSettings.tags) {

          tagsRow = document.createElement('div');
          tagsRow.classList.add("group-info-row");

          // const icon = this.$serviceAreaIcon.cloneNode(true);
          // icon.classList.add("group-icon");
          // tagsRow.insertAdjacentElement('beforeend', icon);

          if (group.tags?.length) {
            group.tags.forEach((t) => {
              const tag = document.createElement('div');
              tag.classList.add('skill-tag');

              const skillText = document.createElement('span')
              skillText.textContent = t;
              tag.appendChild(skillText);
              tagsRow.insertAdjacentElement('beforeend', tag);
            })
          } else {
            // const allSpan = document.createElement('span');
            // allSpan.classList.add("text-ellipsis", "br-body-2", "font-weight-300", "color-primary-100");
            // allSpan.innerHTML = this.$filter('translate')('All');
            // tagsRow.insertAdjacentElement('beforeend', allSpan);
          }
        }

        // nameRow.insertAdjacentElement('beforeend', agentStatusDiv);
        infoContainer.insertAdjacentElement('beforeend', nameRow);

        if (tagsRow) {
          infoContainer.insertAdjacentElement('beforeend', tagsRow.cloneNode(true));
        }

        mainContainer.insertAdjacentElement('beforeend', colorContainer);
        mainContainer.insertAdjacentElement('beforeend', infoContainer);

        const resourceUtilization = _.find(this.resourcesUtilization, (t) => {
          return t.resourceHolderId === group.holderId;
        })

        if (!!resourceUtilization) {
          const totalsContainer = document.createElement('div');
          totalsContainer.classList.add("group-totals-container");

          const totals = document.createElement('span');
          totals.classList.add("totals", "text-ellipsis", "br-body-2", "font-weight-600");

          const conflicts = resourceUtilization.resourceConflictDetails ?? [];

          const plannedTotalMinutes = Math.floor((resourceUtilization.plannedTimeMillis || 0) / (1000 * 60));
          // const plannedHours = Math.floor(plannedTotalMinutes / 60);
          // const plannedMinutes = plannedTotalMinutes % 60;
          //
          const targetTotalMinutes = Math.floor((resourceUtilization.targetTimeMillis || 0) / (1000 * 60));

          const totalConflictTime = conflicts.reduce((total, conflict) => {
            return total + (conflict.endTime - conflict.startTime);
          }, 0);
          // const targetHours = Math.floor(targetTotalMinutes / 60);
          // const targetMinutes = targetTotalMinutes % 60;
          //
          // const plannedFormatted = `${plannedHours}:${plannedMinutes.toString().padStart(2, '0')}`;
          // const targetFormatted = `${targetHours}h`;

          // totals.innerText = `${plannedFormatted}`;

          totals.innerText = `${this._formatDurationHHMM(resourceUtilization.plannedTimeMillis)}${!!totalConflictTime ? ' / ' : ''}${!!totalConflictTime ? this._formatDurationHHMM((resourceUtilization.plannedTimeMillis || 0) + totalConflictTime) : ''}`;

          if (plannedTotalMinutes > targetTotalMinutes) {
            totals.classList.add("risk");
          }

          if (conflicts.length > 0) {
            let tooltipEl: HTMLDivElement | null = null;

            const buildText = () =>
              conflicts
                .map(c => `${c.visitPlanName} = ${this.$filter('serviceTime')(c.endTime - c.startTime)}`)
                .join("\n");

            const positionTooltip = () => {
              if (!tooltipEl) return;

              const rect = totalsContainer.getBoundingClientRect();

              // default position: below-left of totalsContainer
              let left = rect.right + 8;   // 8px gap
              let top = rect.top;          // align to top of element

              // keep inside viewport
              const tipRect = tooltipEl.getBoundingClientRect();
              if (left + tipRect.width > window.innerWidth - 8) {
                left = Math.max(8, window.innerWidth - tipRect.width - 8);
              }
              if (top + tipRect.height > window.innerHeight - 8) {
                top = Math.max(8, rect.top - tipRect.height - 6); // flip above
              }

              tooltipEl.style.top = `${top}px`;
              tooltipEl.style.left = `${left}px`;
            };

            const show = () => {
              if (tooltipEl) return;

              tooltipEl = document.createElement("div");
              tooltipEl.textContent = buildText();

              // IMPORTANT: don't set top/left here at all — we set them via positionTooltip()
              tooltipEl.style.cssText = `
              position: fixed;
              z-index: 2147483647;
              max-width: 420px;

              background: #FFFFFF;
              width: auto;
              padding: 8px;
              margin-bottom: -10px;

              box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.15);
              border-radius: 7px;

              color: #424242;
              opacity: 1;

              font-size: 12px;
              line-height: 1.4;
              white-space: pre-wrap;

              pointer-events: none;
              `;

              document.body.appendChild(tooltipEl);

              // position immediately + after layout
              positionTooltip();
              requestAnimationFrame(positionTooltip);

              this._activeTooltipHides.push(hide);
            };

            const hide = () => {
              tooltipEl?.remove();
              tooltipEl = null;
              const idx = this._activeTooltipHides.indexOf(hide);
              if (idx >= 0) this._activeTooltipHides.splice(idx, 1);
            };

            totalsContainer.addEventListener("mouseenter", show);
            totalsContainer.addEventListener("mouseleave", hide);
            // Window scroll/resize dismiss is handled by a single instance
            // listener registered in $onInit (see _windowHideTooltips).
          }

          totalsContainer.insertAdjacentElement('beforeend', totals);
          mainContainer.insertAdjacentElement('beforeend', totalsContainer);
        }

        return mainContainer;
      },
      onMoving: (item, callback) => {
        if (item.purpose === 'Break') {
          callback(null);
          return;
        }

        if (item.itemType === 'SCHEDULE') {
          callback(item);
          return;
        }

        if (item.stopId || item.stopIds) {
          callback(item);
          return;
        }

        callback(null);
      },
      onMove: (item, callback) => {
        const fromRouteId = item.routeId;
        let schedulesItems;
        let schedulesIds;
        let toRouteId;
        let isBetweenRoutes = false;
        // let isBetweenDays = !this.moment(this.moment(item.start).format("MM/DD/YYYY")).isSame(this.moment(item.startTime).format("MM/DD/YYYY")) &&
        //   !this.moment(this.moment(item.end).format("MM/DD/YYYY")).isSame(this.moment(item.endTime).format("MM/DD/YYYY"));
        //
        // if (isBetweenDays) {
        //   callback(null);
        //   return;
        // }

        const canMove = this._canItemMove(item);

        const groupToRef = this.groupsDataSet.get([item.group])[0];

        const routeToRef = _.find(this.routes, (route) => {
          const routeNotBefore = route.activities[0].notBefore
          const routeNotAfter = route.activities[route.activities.length - 1].notAfter;
          return route.resource.agentId === _.get(groupToRef, 'ref.id') && this.moment(item.start).isBetween(this.moment(routeNotBefore), this.moment(routeNotAfter))
        });

        if (!routeToRef) {
          schedulesItems = this._schedulesToMoveTo(item);

          if (!schedulesItems.length) {
            callback(null);
            return;
          } else {
            const resourceId = schedulesItems[0].id;
            let isPublished = false;

            _.forEach(this.analysis?.resourceHolders, (rh) => {
              _.forEach(rh.resourceAnalysis, (a: VisitScheduleResourceAnalysisModel) => {
                if (a?.resourceId === resourceId) {
                  const publishedRisk = a.risks?.find((r) => {
                    return r === 'OccupiedPublished';
                  })
                  if (!!publishedRisk) {
                    isPublished = true;
                  }
                }
              })
            });

            if (!!isPublished) {
              const agentName = schedulesItems[0].ref?.agentName;
              this.schedulingProjectAlertsService.resourceOccupiedPublishedInfo(agentName);
              callback(null);
              return;
            }

          }
        }

        toRouteId = _.get(routeToRef, 'id');


        if (!!routeToRef?.locked) {
          this.planningAlertsService.routeIsLocked();
          callback(null);
          return;
        }

        if (!canMove) {
          callback(null);
          return;
        }

        const fromRouteDayId = _.find(this.routes, (r) => r.id === fromRouteId)?.visitScheduleDayId;
        const toRouteDayId = routeToRef ? routeToRef.visitScheduleDayId : _.get(schedulesItems, '[0].ref.visitScheduleDayId');

        if (isVisitScheduleDayDispatchedById(this.visitScheduleDays, fromRouteDayId) ||
          isVisitScheduleDayDispatchedById(this.visitScheduleDays, toRouteDayId)) {
          this.schedulingProjectAlertsService.moveJobsDayDispatchedError();
          callback(null);
          return;
        }

        callback(item);

        const fromGroupId = item.group;
        const groupsMap = this.timeline.components[3].groups;
        isBetweenRoutes = !_.isUndefined(toRouteId) && (fromRouteId !== toRouteId);
        const fromOrderedIds = _.chain(groupsMap[fromGroupId].orderedItems.byStart)
          .filter((orderedItem) => {
            return (_.isEqual(orderedItem.data.activityType, 'STOP') || _.isEqual(orderedItem.data.activityType, 'GROUP')) &&
              (_.isEqual(orderedItem.data.id, item.id) || _.isEqual(orderedItem.data.routeId, fromRouteId));
          })
          .map((filteredItem) => {
            return filteredItem.data.stopId || filteredItem.data.stopIds;
          })
          .flatten()
          .value();

        const toOrderedIds = isBetweenRoutes ?
          _.chain(groupsMap[item.group].orderedItems.byStart)
            .filter((orderedItem) => {
              return (_.isEqual(orderedItem.data.activityType, 'STOP') || _.isEqual(orderedItem.data.activityType, 'GROUP')) &&
                (_.isEqual(orderedItem.data.id, item.id) || _.isEqual(orderedItem.data.routeId, toRouteId));
            })
            .map((filteredItem) => {
              return filteredItem.data.stopId || filteredItem.data.stopIds;
            })
            .flatten()
            .value() : undefined;

        // function _getStopsOrderIds(items) {
        //   return _.chain(items)
        //     .filter((item) => {
        //       return _.isEqual(item.data.activityType, 'STOP') || _.isEqual(item.data.activityType, 'GROUP');
        //     })
        //     .map((filteredItem) => {
        //       return filteredItem.data.stopId || filteredItem.data.stopIds;
        //     })
        //     .flatten()
        //     .value();
        // }

        this.onMoveItem(
          {
            jobIds: item.jobIds,
            fromRouteId: fromRouteId,
            toRouteId: toRouteId,
            fromOrderedIds: fromOrderedIds,
            toOrderedIds: toOrderedIds,
            scheduleInstanceId: _.get(schedulesItems, 'length') ? schedulesItems[0].id : undefined,
          }
        );

        // let isUnassigned = _.isEqual(_.get(routeToRef, 'status'), 'Unassigned');
        // const header = !!routeToRef ? (isBetweenRoutes ? 'Move service between routes' : 'Move service in route') : 'Create new route';
        // const text = !!routeToRef ?
        //   (isBetweenRoutes ? 'Would you like to move this service to a another route?' : 'would you like to move this service in the route?') :
        //   'You are about to create a new route';
        //
        // const actions = !!routeToRef ? (_.isEqual(_.get(routeToRef, 'status'), 'Unassigned') ?
        //   this.commonsService.getConfirmActions(['Reset Services']) :
        //   this.commonsService.getConfirmActions(['Assign service to the route associated agent'])) : undefined;
        // this.confirmDialogService.confirmWithActions(header, text, actions)
        //   .then((payload) => {
        //
        //     const fromResourceId = item.resourceId;
        //     const groupsMap = this.timeline.components[3].groups;
        //     const isBetweenRoutes = !_.isUndefined(toRouteId) && (fromRouteId !== toRouteId);
        //
        //     const fromOrderedIds = _.chain(groupsMap[fromResourceId].orderedItems.byStart)
        //       .filter((orderedItem) => {
        //         return !_.isEqual(orderedItem.data.type, 'background') &&
        //           (_.isEqual(orderedItem.data.id, item.id) || _.isEqual(orderedItem.data.routeId, fromRouteId));
        //       })
        //       .map((filteredItem) => {
        //         return filteredItem.data.taskIdList || filteredItem.data.taskId;
        //       })
        //       .flatten()
        //       .value();
        //
        //     const toOrderedIds = isBetweenRoutes ?
        //       _.chain(groupsMap[item.group].orderedItems.byStart)
        //         .filter((orderedItem) => {
        //           return !_.isEqual(orderedItem.data.type, 'background') &&
        //             (_.isEqual(orderedItem.data.id, item.id) || _.isEqual(orderedItem.data.routeId, toRouteId));
        //         })
        //         .map((filteredItem) => {
        //           return filteredItem.data.taskIdList || filteredItem.data.taskId;
        //         })
        //         .flatten()
        //         .value() : undefined;
        //
        //
        //     if (isBetweenRoutes) {
        //       const tasks = this.tasks;
        //       const complementaryTaskIndex = this.tasksService.getComplementaryTaskIndex(item.ref, tasks);
        //
        //       if (complementaryTaskIndex > -1) {
        //         const currentItemIndex = _.findIndex(toOrderedIds, (id) => {
        //           return id === item.id;
        //         })
        //         const complementaryTaskRef = tasks[complementaryTaskIndex];
        //         const complementaryTaskId = tasks[complementaryTaskIndex].bundledTaskList ?
        //           _.find(tasks[complementaryTaskIndex].bundledTaskList, (task: TaskModel) => {
        //             return _.includes(serviceIds, task.serviceId);
        //           }).id : complementaryTaskRef.id;
        //         const isPickup = item.purpose === 'Pickup';
        //         toOrderedIds.splice((isPickup ? (currentItemIndex + 1) : currentItemIndex), 0, complementaryTaskId);
        //       }
        //     }
        //     this.onMoveItem(
        //       {
        //         jobIds: item.jobIds,
        //         fromRouteId: fromRouteId,
        //         toRouteId: toRouteId,
        //         fromOrderedIds: fromOrderedIds,
        //         toOrderedIds: toOrderedIds,
        //       }
        //     );
        //   })
        //   .catch((error) => {
        //     callback(null);
        //     this.$log.info('onMoveTask Error', error);
        //   })

        // if (((!_.isEqual(item.startTime.valueOf(), item.start.valueOf()) && _.isEqual(item.endTime.valueOf(), item.end.valueOf()))
        //     || _.isEqual(item.startTime.valueOf(), item.start.valueOf()) && !_.isEqual(item.endTime.valueOf(), item.end.valueOf())) &&
        //   (fromRouteId === toRouteId)) {
        //
        //   if (!item.ref.taskSpec.detailedServiceTime) {
        //     this.confirmDialogService.confirm('Update Task', 'Are you sure you want to update task?')
        //       .then(() => {
        //         const serviceTime = this.moment(item.end.valueOf()).diff(this.moment(item.start.valueOf()));
        //         // this.onTaskChange({
        //         //   id: item.id,
        //         //   routeId: fromRouteId,
        //         //   serviceTime: serviceTime
        //         // });
        //       })
        //       .catch((error) => {
        //         callback(null);
        //       })
        //   } else {
        //     const route = this.routes.find(r => r.id === fromRouteId);
        //     const taskServiceTime = _.get(route.analysis[item.id], 'serviceTime');
        //     let originTaskEta = _.get(route.analysis[item.id], 'eta');
        //     const originTaskEtd = _.get(route.analysis[item.id], 'etd') || (originTaskEta + taskServiceTime);
        //
        //     const taskNotBefore = _.get(item.ref, 'taskSpec.notBefore');
        //
        //     if (originTaskEta < taskNotBefore) {
        //       originTaskEta = taskNotBefore
        //     }
        //
        //     const originDiff = originTaskEtd - originTaskEta;
        //     const updatedDiff = this.moment(item.end.valueOf()).diff(this.moment(item.start.valueOf()));
        //
        //     const percentageChange = updatedDiff / originDiff;
        //
        //     const originalDetailedServiceTime = item.ref.taskSpec.detailedServiceTime;
        //
        //     const updatedDetailedServiceTime: TaskDetailedServiceTimeModel = {
        //       entryTime: Math.round((originalDetailedServiceTime.entryTime || 0) * percentageChange),
        //       exitTime: Math.round((originalDetailedServiceTime.exitTime || 0) * percentageChange),
        //       workTime: Math.round((originalDetailedServiceTime.workTime || 0) * percentageChange),
        //       packagesTime: Math.round((originalDetailedServiceTime.packagesTime || 0) * percentageChange)
        //     }
        //
        //     this.tasksDialogService.confirmDetailedServiceTimeChange(originalDetailedServiceTime, updatedDetailedServiceTime)
        //       .then((updatedDetailedServiceTime) => {
        //         // this.onTaskChange({
        //         //   id: item.id,
        //         //   routeId: fromRouteId,
        //         //   detailedServiceTime: updatedDetailedServiceTime
        //         // });
        //       })
        //       .catch((error) => {
        //         callback(null);
        //       })
        //   }
        //
        // } else {
        //   let isUnassigned = _.isEqual(_.get(routeToRef, 'status'), 'Unassigned');
        //   const header = !!routeToRef ? (isBetweenRoutes ? 'Move service between routes' : 'Move service in route') : 'Create new route';
        //   const text = !!routeToRef ?
        //     (isBetweenRoutes ? 'Would you like to move this service to a another route?' : 'would you like to move this service in the route?') :
        //     'You are about to create a new route';
        //
        //   const actions = !!routeToRef ? (_.isEqual(_.get(routeToRef, 'status'), 'Unassigned') ?
        //     this.commonsService.getConfirmActions(['Reset Services']) :
        //     this.commonsService.getConfirmActions(['Assign service to the route associated agent'])) : undefined;
        //   this.confirmDialogService.confirmWithActions(header, text, actions)
        //     .then((payload) => {
        //
        //       const fromResourceId = item.resourceId;
        //       const groupsMap = this.timeline.components[3].groups;
        //       const isBetweenRoutes = !_.isUndefined(toRouteId) && (fromRouteId !== toRouteId);
        //
        //       const fromOrderedIds = _.chain(groupsMap[fromResourceId].orderedItems.byStart)
        //         .filter((orderedItem) => {
        //           return !_.isEqual(orderedItem.data.type, 'background') &&
        //             (_.isEqual(orderedItem.data.id, item.id) || _.isEqual(orderedItem.data.routeId, fromRouteId));
        //         })
        //         .map((filteredItem) => {
        //           return filteredItem.data.taskIdList || filteredItem.data.taskId;
        //         })
        //         .flatten()
        //         .value();
        //
        //       const toOrderedIds = isBetweenRoutes ?
        //         _.chain(groupsMap[item.group].orderedItems.byStart)
        //           .filter((orderedItem) => {
        //             return !_.isEqual(orderedItem.data.type, 'background') &&
        //               (_.isEqual(orderedItem.data.id, item.id) || _.isEqual(orderedItem.data.routeId, toRouteId));
        //           })
        //           .map((filteredItem) => {
        //             return filteredItem.data.taskIdList || filteredItem.data.taskId;
        //           })
        //           .flatten()
        //           .value() : undefined;
        //
        //
        //       if (isBetweenRoutes) {
        //         const tasks = this.tasks;
        //         const complementaryTaskIndex = this.tasksService.getComplementaryTaskIndex(item.ref, tasks);
        //
        //         if (complementaryTaskIndex > -1) {
        //           const currentItemIndex = _.findIndex(toOrderedIds, (id) => {
        //             return id === item.id;
        //           })
        //           const complementaryTaskRef = tasks[complementaryTaskIndex];
        //           const complementaryTaskId = tasks[complementaryTaskIndex].bundledTaskList ?
        //             _.find(tasks[complementaryTaskIndex].bundledTaskList, (task: TaskModel) => {
        //               return _.includes(serviceIds, task.serviceId);
        //             }).id : complementaryTaskRef.id;
        //           const isPickup = item.purpose === 'Pickup';
        //           toOrderedIds.splice((isPickup ? (currentItemIndex + 1) : currentItemIndex), 0, complementaryTaskId);
        //         }
        //       }
        //       this.onMoveItem(
        //         {
        //           jobIds: item.jobIds,
        //           fromRouteId: fromRouteId,
        //           toRouteId: toRouteId,
        //           fromOrderedIds: fromOrderedIds,
        //           toOrderedIds: toOrderedIds,
        //         }
        //       );
        //     })
        //     .catch((error) => {
        //       callback(null);
        //       this.$log.info('onMoveTask Error', error);
        //     })
        // }

      },
      snap: function (date, scale, step) {
        var time = 900000; // 15 mins
        return Math.round(date / time) * time;
      },
      // editable: true,
      selectable: true,
      multiselect: false,
      multiselectPerGroup: false,
      xss: {
        disabled: true,
        // filterOptions: {
        //   whiteList: { p: ['class', 'data-from-template'], div: 'class' },
        // },
      },
      editable: {
        add: false,                          // add new items by double tapping
        updateTime: true,                   // drag items horizontally
        updateGroup: true,              // drag items from one group to another
        remove: false,                 // delete an item by tapping the delete button top right
        overrideItems: false          // allow these options to override item.editable
      },
      showTooltips: false,
      tooltip: {
        followMouse: true,
        overflowMethod: 'flip'
      },
      verticalScroll: true,
      zoomKey: "ctrlKey",
      // tooltipOnItemUpdateTime: {
      //   template: function(item) {
      //     // Option to add tooltip when dragging item (useful)
      //     return 'html template for tooltip with <b>item.start</b>: ' + item.start;
      //   }
      // },
      orientation: "top",
      groupEditable: true,
      width: '100%',
      height: '100%',
      margin: {
        item: {horizontal: 10, vertical: 0},
        axis: 5
      },
      // minHeight: '360px',
      stack: false,
      timeAxis: {
        scale: 'day', // minor labels scale
        step: 1       // 1 day per step
      },
      format: {
        minorLabels: {
          minute: this.timeFormat,
          hour: this.timeFormat,
          millisecond: this.timeFormat,
          second: this.timeFormat,
          weekday: 'ddd ' + this.shortDateFormat,
          day: 'ddd ' + this.shortDateFormat,
          week: 'ddd ' + this.shortDateFormat,
          month: this.shortDateFormat,
          year: this.longDateFormat
        },
        majorLabels: {day: ''}
      },
      start: !!this.visitScheduleDays?.length ? this.moment(this.range.dateStart).subtract(1, 'hour') : this.moment().startOf('day'),
      end: !!this.visitScheduleDays?.length ? this.moment(this.range.dateEnd).add(1, 'hour') : this.moment().endOf('day'),
      min: !!this.visitScheduleDays?.length ? this.moment(this.range.dateStart) : this.moment().startOf('day'),
      max: !!this.visitScheduleDays?.length ? this.moment(this.range.dateEnd) : this.moment().endOf('day'),
      // zoomable: false,
      // moveable: false
    };

    const start = moment(this.range.dateStart);
    const end = moment(this.range.dateEnd);

    this.isSingleDay = start.isSame(end, "day");

    if (this.isSingleDay) {
      this.options.timeAxis = {scale: "hour", step: 1};
      this.options.format = {
        minorLabels: {hour: "HH:mm"},
        majorLabels: {day: "dddd, MMM D"}
      }
    } else {
      this.options.timeAxis = {scale: "day", step: 1};
      this.options.format = {
        minorLabels: {
          minute: this.timeFormat,
          hour: this.timeFormat,
          millisecond: this.timeFormat,
          second: this.timeFormat,
          weekday: 'ddd ' + this.shortDateFormat,
          day: 'ddd ' + this.shortDateFormat,
          week: 'ddd ' + this.shortDateFormat,
          month: this.shortDateFormat,
          year: this.longDateFormat
        },
        majorLabels: {day: ''}
      }
    }

    this.timeline = new this.vis.Timeline(this.container, [], this.options);

    // Single delegated click handler — replaces per-cell addEventListener calls
    // inside groupTemplate so listener count stays O(1) regardless of vis redraws.
    this.container.addEventListener('click', this._onContainerClick);

    // Set Timeline
    this.timeline.setGroups(this.groupsDataSet);
    this.timeline.setItems(this.itemsDataSet);

    // Set Table Actions
    const topElementRef = this.timeline.body.dom.top;
    topElementRef.style = 'left: 0px';
    this.tableHeaderDivRef = document.createElement("div");
    this.tableHeaderDivRef.classList.add("resources-list-header-container");

    topElementRef.before(this.tableHeaderDivRef);

    // Init Timeline
    if (this.agents?.length) {

      // Init Agents Groups
      this.groupsDataSet.add(this._getGroupsData(this.agents));

      // Init Routes Utilization/Task Items

      // Add Schedule Items
      if (this.resources?.length) {
        this.itemsDataSet.add(this._getResourceItemsData(this.resources));
        this.itemsDataSet.add(this._getScheduleBreaksItemsData(this.resources));
      }

      // Init Routes Items
      // if (this.routes?.length) {
      //
      //   // Add Routes Background Items
      //   this._addRoutesBackgroundToTimeline(this.routes);
      //
      //   // Add Routes Tasks Items
      //   this.initRoutesTasks(this.tasks);
      // }

      if (this.routes?.length && this.jobs?.length) {
        this._addRoutesToTimeline(this.routes);
        this._addActivitiesToTimeline(this.routes);
        // this.addAgentTotalWorkingHours();
        this.fitTimeline();
        this.isFirstFit = false;
      }
    }

    // Custom Tooltip Events via Service
    this.bringozTimelineService.initCustomTooltip(this.timeline, this.itemsDataSet, 'visit-schedule-timeline');

    // DoubleClick Event
    this.timeline.on('doubleClick', (properties) => {      this._onClicked().then(() => {

        if (properties.what === 'axis') {
          // this.onAxisClick({date: this.moment(properties.time).valueOf()})
          return;
        }

        // Item Click
        if (properties.what === 'item') {
          const item = this.itemsDataSet.get(properties.item);
          if (item?.itemType === 'TASK') {
            this.onInspectRouteClick({id: item.routeId});
          }
        }

        // Item Click
        // if (properties.what === 'item') {
        //   const item = this.itemsDataSet.get(properties.item);
        //
        //   // Schedule Click
        //   if (item.itemType === 'SCHEDULE') {
        //     const agentRef = _.find(this.agents, (a) => {
        //       return a.id === item.agentId
        //     });
        //     this.onScheduleSelect({
        //       schedule: item.ref,
        //       date: item.start.valueOf(),
        //       agent: agentRef
        //     });
        //   }
        //
        //   // Breaks Click
        //   if (item.itemType === 'BREAK') {
        //     const scheduleRef = this.schedules.find((s) => {
        //       return s.id === item.scheduleId;
        //     })
        //     const agentRef = _.find(this.agents, (a) => {
        //       return a.id === item.agentId
        //     });
        //     this.onScheduleSelect({
        //       schedule: scheduleRef,
        //       date: item.start.valueOf(),
        //       agent: agentRef
        //     });
        //   }
        //
        //   // Task Click
        //   if (item.itemType === 'TASK' && properties.what === 'item') {
        //     this.onViewService({ids: item.serviceIds || [item.serviceId]});
        //   }
        //
        // }

        // let startDate;
        // let endDate;
        // if (properties.group && !_.get(properties, 'item')) {
        //   const agent = _.find(this.agents, (a) => {
        //     return a.id === properties.group
        //   });
        //   if (agent) {
        //     let selectedDate = undefined;
        //     if (_.isEqual(_.get(properties, 'what'), 'background') && _.get(properties, 'time')) {
        //       selectedDate = (properties.time).getTime();
        //       startDate = this.moment(selectedDate).startOf('day').valueOf()
        //       endDate = this.moment(selectedDate).endOf('day').minute(45).seconds(0).millisecond(0).valueOf();
        //     }
        //     this.onCreateSchedule({agent: agent, startDate: startDate, endDate: endDate});
        //   }
        // }
      })
      properties.event.preventDefault();
    });

    this.timeline.itemSet.groupHammer.off('tap');

    // if (this.routes?.length && this.jobs?.length) {
    //   // this._addRoutesToTimeline(this.routes);
    //   this._addActivitiesToTimeline(this.routes);
    //   this.fitTimeline();
    //   this.isFirstFit = false;
    // }

    // // Select Event
    // this.timeline.on('select', (properties) => {
    //   properties.event.preventDefault();
    //   this._onClicked().then(() => {
    //     const selectedItemIds = this.timeline.getSelection();
    //
    //     const highlightedSchedules = [];
    //     let highlightedTasks = [];
    //     const highlightedRoutes = [];
    //
    //     _.forEach(selectedItemIds, (itemId) => {
    //       const selectedItem = this.itemsDataSet.get(itemId);
    //
    //       // const agent = _.find(this.agents, (a) => {
    //       //   return a.id === selectedItem.ref.agentId;
    //       // })
    //
    //       if (selectedItem.itemType === 'SCHEDULE') {
    //         highlightedSchedules.push(selectedItem.ref)
    //         const scheduleRoute = this._getRouteByScheduleId(selectedItem.id);
    //
    //         if (!!scheduleRoute) {
    //           scheduleRoute.color = this._getColorByAgentId(selectedItem.agentId);
    //           highlightedRoutes.push(scheduleRoute)
    //         }
    //       }
    //
    //       if (selectedItem.itemType === 'BREAK') {
    //         const scheduleRef = _.find(this.schedules, (s) => {
    //           return selectedItem.scheduleId === s.id;
    //         })
    //         const scheduleRoute = this._getRouteByScheduleId(selectedItem.scheduleId);
    //
    //         if (!!scheduleRef) {
    //           highlightedSchedules.push(scheduleRef)
    //         }
    //
    //         if (!!scheduleRoute) {
    //           scheduleRoute.color = this._getColorByAgentId(selectedItem.agentId);
    //           highlightedRoutes.push(scheduleRoute)
    //         }
    //       }
    //
    //       if (selectedItem.itemType === 'TASK') {
    //         highlightedTasks.push(selectedItem.ref)
    //
    //         const route = _.find(this.routes, (r) => {
    //           return r.id === selectedItem.ref.routeId;
    //         })
    //         if (!!route &&
    //           !_.includes(selectedItemIds, selectedItem.ref.routeId) && !_.includes(_.map(highlightedRoutes, 'id'), selectedItem.ref.routeId)) {
    //           highlightedRoutes.push(route)
    //         }
    //       }
    //
    //     })
    //
    //     // Supporting only one task selected.
    //     if (highlightedTasks.length > 1) {
    //       highlightedTasks = [_.last(highlightedTasks)];
    //     }
    //
    //     this.onHighlightedItemsChange({
    //       highlightedSchedules: _.uniq(highlightedSchedules),
    //       highlightedTasks: highlightedTasks,
    //       highlightedRoutes: highlightedRoutes
    //     });
    //     properties.event.preventDefault();
    //   });
    // });
    //
    // // Right Click Event
    // this.timeline.on('contextmenu', (properties) => {
    //   if (_.get(properties, 'item')) {
    //     const item = this.itemsDataSet.get(properties.item);
    //     const event = properties.event;
    //
    //     if (item.itemType === 'TASK') {
    //       this._onClicked().then(() => {
    //         this.onRightClickTask({task: item.ref, agentId: item.agentId, event: event});
    //       })
    //     }
    //
    //     if (item.itemType === 'BREAK') {
    //       this._onClicked().then(() => {
    //         const scheduleRef = this.schedules.find((s) => {
    //           return s.id === item.scheduleId;
    //         })
    //         this.onBreakRightClick({schedule: scheduleRef, event: event})
    //       })
    //     }
    //
    //     if (item.itemType === 'SCHEDULE') {
    //       this._onClicked().then(() => {
    //         this.onRightClickSchedule({schedule: item.ref, event: event});
    //       })
    //     }
    //
    //   }
    //   properties.event.preventDefault();
    // });
    //
    // // Hover
    // this.timeline.on('mouseOver', (props) => {
    //   if (props.item) {
    //     this._onClicked().then(() => {
    //
    //     });
    //   }
    // });


    this.timeline.on('changed', () => {

      if (!this.isDrawing) {
        this.isDrawing = true;

        this.$timeout(300).then(() => {
          requestAnimationFrame(() => {

            if (this.isSingleDay) {
              this.isDrawing = false;
              return;
            }
            ;
            const headers = document.querySelectorAll('.vis-text.vis-minor');

            headers.forEach((header, index) => {
              if (index === 0) return; // skip first header if needed

              const visitScheduleDay = this.visitScheduleDays[index - 1];

              // ----- Dispatch Indication -----
              if (!header.querySelector('.dispatch-indication') && (visitScheduleDay?.totals.dispatched || visitScheduleDay?.totals.partialDispatched)) {
                const title = visitScheduleDay?.totals.dispatched ? 'Dispatched' : 'Partial Dispatched'
                const dispatchIndication = angular.element('<span class="dispatch-indication br-body-1 font-weight-400">'+ title +'</span>');
                this.$compile(dispatchIndication)(this.$scope);

                dispatchIndication.css({
                  position: 'absolute',
                  right: '40px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  'z-index': 10
                });

                header.appendChild(dispatchIndication[0]);
              }

              // ----- Map Icon -----
              if (!header.querySelector('.map-toggle-icon')) {
                const mapIcon = angular.element('<bringoz-icon icon-name="map" class="map-toggle-icon"></bringoz-icon>');
                this.$compile(mapIcon)(this.$scope);

                mapIcon.css({
                  position: 'absolute',
                  right: '5px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  'z-index': 10
                });

                mapIcon.on('click', (event) => {
                  event.stopPropagation();
                  this.onToggleMap({visitScheduleDay: visitScheduleDay});
                });

                header.appendChild(mapIcon[0]);
              }

              // ----- New Icon -----
              // if (!header.querySelector('.dispatch-toggle-icon')) {
              //   const dispatchIcon = angular.element('<bringoz-icon icon-name="table" class="dispatch-toggle-icon"></bringoz-icon>');
              //   this.$compile(dispatchIcon)(this.$scope);
              //
              //   dispatchIcon.css({
              //     position: 'absolute',
              //     right: '22px',
              //     top: '50%',
              //     transform: 'translateY(-50%)',
              //     'z-index': 10
              //   });
              //
              //   dispatchIcon.on('click', (event) => {
              //     event.stopPropagation();
              //     this.onDispatchDay({visitScheduleDay: visitScheduleDay});
              //   });
              //
              //   header.appendChild(dispatchIcon[0]);
              // }
            });

            this.isDrawing = false;
          });
        })

      }

    });


    // this.timeline.on('changed', () => {
    //   requestAnimationFrame(() => {
    //
    //     if (this.isSingleDay) return;
    //     const headers = document.querySelectorAll('.vis-text.vis-minor');
    //
    //     headers.forEach((header, index) => {
    //       if (index === 0) return; // skip first header if needed
    //
    //       const visitScheduleDay = this.visitScheduleDays[index - 1];
    //
    //       // ----- Dispatch Indication -----
    //       if (!header.querySelector('.dispatch-indication') && visitScheduleDay?.totals.dispatched) {
    //         const dispatchIndication = angular.element('<span class="dispatch-indication br-body-1 font-weight-400">Dispatched</span>');
    //         this.$compile(dispatchIndication)(this.$scope);
    //
    //         dispatchIndication.css({
    //           position: 'absolute',
    //           right: '40px',
    //           top: '50%',
    //           transform: 'translateY(-50%)',
    //           'z-index': 10
    //         });
    //
    //         header.appendChild(dispatchIndication[0]);
    //       }
    //
    //       // ----- Map Icon -----
    //       if (!header.querySelector('.map-toggle-icon')) {
    //         const mapIcon = angular.element('<bringoz-icon icon-name="map" class="map-toggle-icon"></bringoz-icon>');
    //         this.$compile(mapIcon)(this.$scope);
    //
    //         mapIcon.css({
    //           position: 'absolute',
    //           right: '5px',
    //           top: '50%',
    //           transform: 'translateY(-50%)',
    //           'z-index': 10
    //         });
    //
    //         mapIcon.on('click', (event) => {
    //           event.stopPropagation();
    //           this.onToggleMap({visitScheduleDay: visitScheduleDay});
    //         });
    //
    //         header.appendChild(mapIcon[0]);
    //       }
    //
    //       // ----- New Icon -----
    //       if (!header.querySelector('.dispatch-toggle-icon')) {
    //         const dispatchIcon = angular.element('<bringoz-icon icon-name="table" class="dispatch-toggle-icon"></bringoz-icon>');
    //         this.$compile(dispatchIcon)(this.$scope);
    //
    //         dispatchIcon.css({
    //           position: 'absolute',
    //           right: '22px',
    //           top: '50%',
    //           transform: 'translateY(-50%)',
    //           'z-index': 10
    //         });
    //
    //         dispatchIcon.on('click', (event) => {
    //           event.stopPropagation();
    //           this.onDispatchDay({visitScheduleDay: visitScheduleDay});
    //         });
    //
    //         header.appendChild(dispatchIcon[0]);
    //       }
    //     });
    //   });
    // });

    this.timeline.on('contextmenu', (props) => {
      if (props.item && !this.visitPlan.hasNotSyncedChanges) {
        const activity = this._getTimelineItemById(props.item);
        if (!!activity) {
          this._onClicked().then(() => {
            this.onJobRightClick({
              jobIds: activity.jobIds,
              routeId: activity.routeId,
              event: props.event
            })
          });
        }
        props.event.preventDefault();
      }
    });


  };

  // private addAgentTotalWorkingHours() {
  //   const agents = angular.copy(this.agents);
  //
  //   agents?.forEach(a => {
  //     const agentRoutes = this.routes?.filter(r => r.resource.agentId === a.id);
  //     a.totalWorkingHours = 0;
  //     a.totalWorkingHours += ((_.reduce(agentRoutes, (sum: any, route) => {
  //       return sum + (route.totals.totalTimeSec || 0);
  //     }, 0)) / 60 / 60).toFixed(2);
  //   })
  //
  //   this.redrawGroupTemplate();
  // }

  $onChanges(changes: angular.IOnChangesObject) {

    if (changes.agents && !changes.agents.isFirstChange()) {
      const currentAgents = changes.agents.currentValue || [];
      const previousAgents = changes.agents.previousValue || [];

      const agentsToAdd = _.differenceBy(currentAgents, previousAgents, 'id');
      const agentsToRemove = _.differenceBy(previousAgents, currentAgents, 'id');


      const currentUpdatedAgents = _.differenceBy(currentAgents, agentsToAdd, 'id');
      const previousUpdatedAgents: any = _.differenceBy(previousAgents, agentsToRemove, 'id');

      const currentAgentsToUpdate = _.filter(currentUpdatedAgents, (currentUpdatedAgent: any) => {
        const previousUpdatedAgent = _.find(previousUpdatedAgents, ['id', currentUpdatedAgent.id]);
        // Check if route was changed
        return previousUpdatedAgent.updatedAt < currentUpdatedAgent.updatedAt;
      });

      // Remove
      if (agentsToRemove.length) {
        this.groupsDataSet.remove(_.map(agentsToRemove, 'id'));
      }


      // Update
      if (!!currentAgentsToUpdate.length) {
        const currentAgentsIdsToUpdate = _.map(currentAgentsToUpdate, 'id');
        const updatedGroups = this._getGroupsData(currentAgentsToUpdate);
        this.groupsDataSet.update(updatedGroups);
      }

      // Add
      if (agentsToAdd.length) {
        this.groupsDataSet.add(this._getGroupsData(agentsToAdd));
      }

      const numberOfAgents = _.get(this.agents, 'length', 0);
      this.options.height = numberOfAgents === 0 ? '100%' : null;
      this.options.orientation = 'top'
      this.timeline.setOptions(this.options);

      this.$timeout(0).then(() => {
        this._setExpandedGroupsRoutes(this.isExpandedRoutes, true);
      })
    }

    if (changes.resources && !changes.resources.isFirstChange()) {
      this._clearScheduleItems();
      this.itemsDataSet.add(this._getResourceItemsData(this.resources));
      // this.itemsDataSet.add(this._getScheduleBreaksItemsData(this.resources));
    }

    if (
      (changes.resources && !changes.resources.isFirstChange()) ||
      (changes.analysis && !changes.analysis.isFirstChange())
    ) {
      this._clearScheduleRisksBackgroundItems();
      this.itemsDataSet.add(this._getResourceRisksBackgroundItemsData(this.analysis?.resourceHolders));
      // this.itemsDataSet.add(this._getScheduleBreaksItemsData(this.resources));
    }

    if (changes.jobs && !changes.jobs.isFirstChange()) {
      if (this.routes?.length && this.jobs?.length) {
        this.itemsDataSet?.clear();
        this._addActivitiesToTimeline(this.routes);
        // this.addAgentTotalWorkingHours();
        this.fitTimeline();
        this.isFirstFit = false;
      }
    }


    if (changes.resourcesUtilization && !changes.resourcesUtilization.isFirstChange()) {
      if (this.agents?.length) {
        this.redrawGroupTemplate();
      }
    }


    // if (changes.routes && !changes.routes.isFirstChange()) {
    //   // const currentRoutes = changes.routes.currentValue || [];
    //   // const previousRoutes = changes.routes.previousValue || [];
    //   //
    //   // const routesToAdd = _.differenceBy(currentRoutes, previousRoutes, 'id');
    //   // const routesToRemove = _.differenceBy(previousRoutes, currentRoutes, 'id');
    //   //
    //   //
    //   // const currentUpdatedRoutes = _.differenceBy(currentRoutes, routesToAdd, 'id');
    //   // const previousUpdatedRoutes: any = _.differenceBy(previousRoutes, routesToRemove, 'id');
    //   //
    //   // const currentRoutesToUpdate = _.filter(currentUpdatedRoutes, (currentUpdatedRoute: any) => {
    //   //   const previousUpdatedRoute = _.find(previousUpdatedRoutes, ['id', currentUpdatedRoute.id]);
    //   //   // Check if route was changed
    //   //   return previousUpdatedRoute.updatedTime < currentUpdatedRoute.updatedTime;
    //   // });
    //   //
    //   // // Routes - REMOVE LINE TASKS
    //   // if (!!routesToRemove.length) {
    //   //   // groupsDataSet.remove(_.map(routesToRemove, 'id'));
    //   //   this.itemsDataSet.remove(_.map(routesToRemove, 'id'));
    //   // }
    //   //
    //   // // Routes - UPDATE LINE TASKS
    //   // if (!!currentRoutesToUpdate.length) {
    //   //   const updatedRouteItems = [];
    //   //   _.forEach(currentRoutesToUpdate, (r) => {
    //   //     updatedRouteItems.push(this._getRouteBackgroundItem(r));
    //   //   })
    //   //   this._updateTimelineTasks(updatedRouteItems);
    //   // }
    //   //
    //   // // Routes - ADD LINE TASKS
    //   // if (routesToAdd.length) {
    //   //   this._addRoutesBackgroundToTimeline(routesToAdd);
    //   // }
    //   // // this.initRoutesTasks(this.routes);
    //   //
    //   // this.redrawGroupTemplate();
    // }

    if (changes.routes && !changes.routes.isFirstChange()) {
      const currentRoutes = changes.routes.currentValue || [];
      const previousRoutes = changes.routes.previousValue || [];

      // PlanningDraftService.getRoutesChanges(currentRoutes, previousRoutes)

      const routesToAdd: any[] = _.differenceBy(currentRoutes, previousRoutes, 'id');
      const routesToRemove: any[] = _.differenceBy(previousRoutes, currentRoutes, 'id');

      const currentUpdatedRoutes = _.differenceBy(currentRoutes, routesToAdd, 'id');
      const previousUpdatedRoutes = _.differenceBy(previousRoutes, routesToRemove, 'id');

      const currentRoutesToUpdate = _.filter(currentUpdatedRoutes, (currentUpdatedRoute: any) => {
        let previousUpdatedRoute: any = _.find(previousUpdatedRoutes, ['id', currentUpdatedRoute.id]);

        // Check if route was changed
        return (_.get(previousUpdatedRoute, 'activities.length') !== _.get(currentUpdatedRoute, 'activities.length')) ||
          (previousUpdatedRoute.updatedAt < currentUpdatedRoute.updatedAt);
      });

      const previousRoutesToUpdate = _.filter(previousUpdatedRoutes, (previousUpdatedRoute: any) => {
        const currentUpdatedRoute: any = _.find(currentUpdatedRoutes, ['id', previousUpdatedRoute.id]);
        // Check if route was changed
        return (_.get(currentUpdatedRoute, 'activities.length') !== _.get(previousUpdatedRoute, 'activities.length')) ||
          previousUpdatedRoute.updatedAt < currentUpdatedRoute.updatedAt;
      });

      // Remove groups and items
      const activitiesToRemove = _.flatMap(_.concat(routesToRemove, previousRoutesToUpdate), 'activities');
      const activityItemIdsToRemove = _.map(activitiesToRemove, 'id');
      let routesToRemoveBackgroundItems = [];
      let routesToRemoveTripItems = [];
      routesToRemove.forEach(r => {
        r.activities.forEach(a => {
          routesToRemoveBackgroundItems.push(r.id);

          if (a.tripNumber) {
            routesToRemoveTripItems = _.uniq(routesToRemoveTripItems.concat(r.id + a.tripNumber));
          }
        })
      })
      let previousRoutesToUpdateBackgroundItems = [];
      previousRoutesToUpdate.forEach(r => {
        r.activities.forEach(a => {
          previousRoutesToUpdateBackgroundItems.push(r.id + a.id);
        })
      })
      const backgroundItemIdsToRemove = _.concat(routesToRemoveBackgroundItems, routesToRemoveTripItems, previousRoutesToUpdateBackgroundItems);
      // const routeIdsToRemove = _.map(routesToRemove, 'id');


      // if (routeIdsToRemove.length) {
      //   this.groupsDataSet.remove(routeIdsToRemove);
      // }

      if (_.concat(activityItemIdsToRemove, backgroundItemIdsToRemove).length) {
        this.itemsDataSet.remove(_.concat(activityItemIdsToRemove, backgroundItemIdsToRemove));
      }

      // Create groups and items
      // var routesToAddAndUpdate = _.concat(routesToAdd, routesToUpdate);
      this.$timeout(() => {
        this._addRoutesToTimeline(routesToAdd);
        this._addActivitiesToTimeline(_.concat(routesToAdd, currentRoutesToUpdate));
        this._recalcDailyWorkingHours();
        // this.addAgentTotalWorkingHours();
      }, 0);
      // var groupsToAdd = _mapRoutesToGroups(routesToAdd, ctrl.draftAnalysis);
      // var activityItemsToAdd = _mapRoutesToActivityItems(_.concat(routesToAdd, currentRoutesToUpdate), ctrl.draftAnalysis);
      // var backgroundItemsToAdd = _mapRoutesToBackgroundItems(_.concat(routesToAdd, currentRoutesToUpdate));
      //
      // groupsDataSet.add(_.sortBy(groupsToAdd, ['resourceName', 'eta']));
      // itemsDataSet.add(_.concat(activityItemsToAdd, backgroundItemsToAdd));

      // Update groups and items

      // if (currentRoutesToUpdate.length) {
      //   const groupsToUpdate = this._mapRoutesToGroups(currentRoutesToUpdate);
      //   this.groupsDataSet.update(groupsToUpdate);
      // }

      if (!!currentRoutesToUpdate.length) {
        const updatedRouteItems = [];
        _.forEach(currentRoutesToUpdate, (r) => {
          updatedRouteItems.push(this._getRouteBackgroundItem(r));
        })
        this._updateTimelineTasks(updatedRouteItems);
      }

      if (this.isFirstFit) {
        this.fitTimeline();
        this.isFirstFit = false;
      }
    }

    if (changes.tasks && !changes.tasks.isFirstChange()) {
      // this.initRoutesTasks(this.tasks);
    }

    if (changes.analysis && !changes.analysis.isFirstChange()) {
      const routeIds = this.analysis?.routes.map((r) => {
        return r.routeId;
      })
      const routesToUpdate = this.routes?.filter((r) => {
        return _.includes(routeIds, r.id);
      })
      this._redrawRoutes(routesToUpdate);
      this._recalcDailyWorkingHours();
    }

    if (changes.range && !changes.range.isFirstChange()) {
      this.options.start = this.moment(this.range.dateStart) ? this.moment(this.range.dateStart).subtract(1, 'hour') : this.moment().startOf('day');
      this.options.end = this.moment(this.range.dateEnd) ? this.moment(this.range.dateEnd).add(1, 'hour') : this.moment().endOf('day');
      this.options.min = this.moment(this.range.dateStart);
      this.options.max = this.moment(this.range.dateEnd);

      const start = moment(this.range.dateStart);
      const end = moment(this.range.dateEnd);

      this.isSingleDay = start.isSame(end, "day");

      if (this.isSingleDay) {
        this.options.timeAxis = {scale: "hour", step: 1};
        this.options.format = {
          minorLabels: {hour: "HH:mm"},
          majorLabels: {day: "dddd, MMM D"}
        }
      } else {
        this.options.timeAxis = {scale: "day", step: 1};
        this.options.format = {
          minorLabels: {
            minute: this.timeFormat,
            hour: this.timeFormat,
            millisecond: this.timeFormat,
            second: this.timeFormat,
            weekday: 'ddd ' + this.shortDateFormat,
            day: 'ddd ' + this.shortDateFormat,
            week: 'ddd ' + this.shortDateFormat,
            month: this.shortDateFormat,
            year: this.longDateFormat
          },
          majorLabels: {day: ''}
        }
      }

      this.timeline.setOptions(this.options);
      this.timeline.setWindow(new Date(this.range.dateStart), new Date(this.range.dateEnd));
    }

    if (changes.isTooltipsEnabled && !changes.isTooltipsEnabled.isFirstChange()) {
      // this.options.showTooltips = !!this.isTooltipsEnabled;
      // this.timeline.setOptions(this.options);
    }

    if (changes.isShowTaskColorByAgent && !changes.isShowTaskColorByAgent.isFirstChange()) {
      // this._redrawTasks(this.tasks)
    }

    if (changes.isLoading && !changes.isLoading.isFirstChange()) {
      // this.options.editable = {
      //   add: true,
      //   updateTime: !this.isLoading,
      //   updateGroup: !this.isLoading,
      //   remove: false,
      //   overrideItems: true
      // };
      // this.timeline.setOptions(this.options);
    }
  };

  // ******************************
  //        Public methods
  // ******************************

  toggleMap() {
    const vsd = this.visitScheduleDays.find(
      item => item.date >= this.range.dateStart && item.date <= this.range.dateEnd
    );

    this.onToggleMap({visitScheduleDay: vsd});
  }

  dispatchDay() {
    const vsd = this.visitScheduleDays.find(
      item => item.date >= this.range.dateStart && item.date <= this.range.dateEnd
    );

    this.onDispatchDay({visitScheduleDay: vsd});
  }

  initRoutesTasks(tasks) {

    // Server Bugfixes
    _.forEach(tasks, (t) => {
      if (t.packageList?.length) {
        if (t.packageList[0] && !t.packageList[0].items) {
          t.packageList[0] = {items: t.packageList[0]};
        }
      }

      // t.routeId = r.id;
      const routeRef = _.find(this.routes, (r) => {
        return r.id === t.routeId;
      })
      if (!!routeRef) {
        t.agentId = routeRef.agentId;
      }
    })

    this._setTasks(tasks)
  }

  private _setTasks(tasks) {
    let tasksToAdd = [];
    let idsToRemove = [];
    let idsToUpdate = [];

    const taskIds = _.flatMap(tasks, 'id');
    const currentTimelineItems = [];
    this.itemsDataSet.forEach((item) => {
      if (item.itemType === 'TASK') {
        currentTimelineItems.push(item.id);

        if (_.includes(taskIds, item.id)) {
          const taskRef = _.find(tasks, (t) => {
            return t.id === item.id;
          })
          if (_.get(taskRef, 'updatedAt', 0) >= _.get(item, 'updatedAt', 0)) {
            idsToUpdate.push(item.id);
          }
        }

      }
    });
    idsToRemove = _.filter(currentTimelineItems, (currentItemId) => {
      return !_.includes(taskIds, currentItemId);
    })
    tasksToAdd = _.filter(tasks, (t) => {
      return !_.includes(currentTimelineItems, t.id);
    })

    // Remove
    if (idsToRemove.length) {
      this.itemsDataSet.remove(idsToRemove);
    }

    // Update
    if (idsToUpdate.length) {
      const tasksToUpdate = _.filter(tasks, (t) => {
        return _.includes(idsToUpdate, t.id);
      })
      const taskItemsToUpdate = this._getTasksItemsData(tasksToUpdate);

      if (_.get(taskItemsToUpdate, 'length')) {
        this.itemsDataSet.remove(_.map(taskItemsToUpdate, 'id'))
        this.itemsDataSet.add(taskItemsToUpdate);

        // itemsDataSet.update(taskItemsToUpdate);
      }
    }

    // Add
    if (tasksToAdd.length) {
      const taskItemsToAdd = this._getTasksItemsData(tasksToAdd);

      if (_.get(taskItemsToAdd, 'length')) {
        this.itemsDataSet.remove(_.map(taskItemsToAdd, 'id'))
        this.itemsDataSet.add(taskItemsToAdd);
      }
    }
  }

  onZoom(isZoomIn) {
    isZoomIn ? this.timeline.zoomIn(0.5) : this.timeline.zoomOut(0.5);
  }

  onExpand(isExpandedRoutes) {
    this.isExpandedRoutes = isExpandedRoutes;
    this._setExpandedGroupsRoutes(isExpandedRoutes);
  }

  fitTimeline() {
    this.$timeout(200).then(() => {
      this._onFit();
    });
  }

  private _onFit() {
    this.timeline.fit();
  }

  onGroupsViewSettingsChange(updatedGroupsViewSettings) {
    this.groupsViewSettings = updatedGroupsViewSettings;
    this.redrawGroupTemplate();
  }

  public _addRoutesToTimeline(routes) {

    // Make sure the routes doesnt exist in timeline before adding them.
    // const currentRouteIdsInTimeline = this.groupsDataSet.getIds();
    // routes = _.filter(routes, (r) => {
    //   return !_.includes(currentRouteIdsInTimeline, r.id);
    // })
    //
    // const groups = this._mapRoutesToGroups(routes);

    let backgroundItems = [];

    _.forEach(routes, (r) => {
      backgroundItems = backgroundItems.concat(this._getRouteBackgroundItem(r));
    });

    this.itemsDataSet.add(_.concat(backgroundItems));

    // this.groupsDataSet.add(_.sortBy(groups, ['resourceName', 'eta']));
  }

  private _getRouteBackgroundItem(route) {
    const start = route.activities[0].eta;
    const end = _.last(route.activities)['etd'];

    return {
      id: route.id,
      ref: route,
      routeId: route.id,
      start: this.moment(start),
      end: this.moment(end),
      group: _.get(route, 'resource.resourceHolderId'),
      type: 'background',
      itemType: 'ROUTE',
      className: 'route-background'
    }
  }

  private _getRouteTotalBackgroundItem(resourceHolderId, date, routes: any[]) {

    let totalDuration = 0;
    let resourceIds = [];
    // let totalRiskTime = 0;
    routes.forEach((r) => {

      const resourceRef = this.resources?.find((resource) => {
        return resource.id === r.resourceId;
      });

      if (!!resourceRef) {
        resourceIds.push(resourceRef.id);
      }

      if (r.totals?.totalTimeSec) {
        totalDuration += r.totals.totalTimeSec * 1000
      } else {
        const start = r.activities[0].eta;
        // const end = _.last(r.activities)['etd'];

        const lastActivity = _.last(r.activities);
        const lastActivityEta = _.get(lastActivity, 'eta');
        const activityServiceTimeInMili = _.get(lastActivity, 'serviceTime', 5) * 60000;
        const end = _.get(lastActivity, 'etd', (lastActivityEta || 0) + activityServiceTimeInMili);

        totalDuration += this._calcDurationMs(start, end)
      }

    });

    // const resourceUtilization = _.find(this.resourcesUtilization, (t) => {
    //   return t.resourceHolderId === agentId;
    // })
    // const conflicts = resourceUtilization?.resourceConflictDetails ?? [];
    // const totalConflictTime = conflicts.reduce((total, conflict) => {
    //   if (this.moment(this.moment(conflict.startTime).format("MM/DD/YYYY")).isSame(this.moment(date).format("MM/DD/YYYY"))) {
    //     return total + (conflict.endTime - conflict.startTime);
    //   } else {
    //     return 0
    //   }
    // }, 0);

    // const resourceRef = this.resources?.find((r) => {
    //   return agentId === r.agentId && this.moment(r.startTime).isSame(this.moment(date), 'date');
    // });

    let totalConflictTime = 0;
    _.forEach(this.analysis?.resourceHolders, (rh) => {
      _.forEach(rh.resourceAnalysis, (a: VisitScheduleResourceAnalysisModel) => {
        // const resourceRef = this.resources?.find((r) => {
        //   return a.resourceId === r.id;
        // });
        if (_.includes(resourceIds, a.resourceId)) {
          if (a.risksData.OccupiedPublished) {
            totalConflictTime = a.risksData.OccupiedPublished.reduce((total, conflict) => {
              return total + (conflict.endTime - conflict.startTime);
            }, 0);
          }
        }
      })
    });

    const dailyWorkingHours = this._formatDurationHHMM(totalDuration);
    const totalConflictTimeFormatted = this._formatDurationHHMM(totalDuration + totalConflictTime);

    return {
      id: resourceHolderId + date,
      start: this.moment(date).startOf('day'),
      end: this.moment(date).startOf('day'),
      group: resourceHolderId,
      type: 'background',
      itemType: 'TOTAL',
      content: `<span class="total-label">${dailyWorkingHours}${!!totalConflictTime ? ' / ' + totalConflictTimeFormatted : ''}</span>`,
      className: 'route-total-background'
    }

    // items.add({
    //   id: `d-${groupId}-${dayStart.toISOString().slice(0,10)}`,
    //   group: groupId,
    //   start: dayStart,
    //   end: dayEnd,              // next midnight
    //   type: "background",
    //   selectable: false,
    //   className: "day-start-marker",
    //   content: `<span class="day-start-label">${text}</span>`,
    // });
  }


  public _mapRoutesToGroups(routes) {
    return _.map(routes, (route) => {
      const color = this._getRouteColor(route.id);
      return this._getGroupData(route, color);
    });
  }

  public _mapRoutesToBackgroundItems(routes) {
    // return _.flatMap(routes, (route) => {
    //   const color = this._getRouteColor(route.id);
    //   return this._mapRouteToBackgroundItem(route, color);
    // });
    let backgroundItems = [];
    routes.forEach((route) => {
      const color = this._getRouteColor(route.id);
      const items = this._mapRouteToBackgroundItem(route, color)
      backgroundItems.push(...items);
    })
    return backgroundItems;
  }

  public _mapRouteToBackgroundItem(route, color) {
    let backgroundItems = [];

    let currentPackagesOnCurrentLocation = [];

    route.activities.forEach((activity, index) => {
      if (!route.activities[index + 1]) {
        return;
      }

      if (activity.stopType === 'Pickup') {
        currentPackagesOnCurrentLocation.push(...activity.packages);
      }

      if (activity.stopType === 'Dropoff') {
        activity.packages.forEach(activityPackage => {
          const packageIndex = currentPackagesOnCurrentLocation.findIndex(currentPackage => activityPackage.id === currentPackage.id);
          if (packageIndex > -1) {
            currentPackagesOnCurrentLocation.splice(packageIndex, 1)
          }
        })
      }
      const backgroundItem: any = {
        id: route.id + activity.id,
        start: this.moment(activity.eta),
        end: this.moment(route.activities[index + 1].eta),
        group: route.id,
        type: 'background',
        style: 'background-color: ' + color,
        className: `route-background ${!currentPackagesOnCurrentLocation.length ? 'empty' : ''}`
      }

      backgroundItems.push(backgroundItem);
    })
    return backgroundItems;
  }

  public _addActivitiesToTimeline(routes) {
    const activityItems = this._mapRoutesToActivityItems(routes);
    const routeIds = _.map(routes, 'id');
    let reTripItems = [];

    // // Remove RoutesRetripItems
    // const itemsToRemove = [];
    // this.itemsDataSet.forEach((item) => {
    //   if (item.isRetrip && _.includes(routeIds, item.routeId)) {
    //     retripItemIdsToRemove.push(item.id);
    //   }
    // })

    // if (retripItemIdsToRemove.length) {
    //   this.itemsDataSet.remove(retripItemIdsToRemove);
    // }

    const backgroundItems: any = this._mapRoutesToBackgroundItems(routes);
    const itemIdsToRemoveBeforeAdd = _.map(_.concat(activityItems, reTripItems, backgroundItems), 'id');


    const itemsToRemove = [];
    this.itemsDataSet.forEach((item) => {
      if (_.includes(itemIdsToRemoveBeforeAdd, item.id) || (item.isRetrip && _.includes(routeIds, item.routeId))) {
        itemsToRemove.push(item.id);
      }
    })

    if (itemsToRemove.length) {
      this.itemsDataSet.remove(itemsToRemove);
    }

    this.$timeout(0).then(() => {
      const itemsList = _.concat(activityItems, reTripItems, backgroundItems);
      this.itemsDataSet.add(itemsList);
      this.fitTimeline();
    });
  }


  // ******************************
  //        Private methods
  // ******************************

  private _getStartEndPointsContent(activity, routeColor) {
    const stopType = activity.type;
    const label = this.$filter('translate')(stopType === 'START' ? 'S' : 'E');
    return '<span class="br-body-2 font-weight-400 ' + label + '">' + label + '</span>'
      + '<div class="dot" style="background-color: ' + routeColor + '"></div>'
  }

  private _getStopContent(activity, color) {

    const stopType = activity.stopType || activity.type;
    const activityType = activity.type;
    const tripNumber = activity.tripNumber;
    const itemType = stopType || activityType;
    const isGroup = _.isEqual(activity.type, 'GROUP');


    // const defaultServiceTime = 60000;
    // const activityServiceTimeInMili = _.get(activity, 'serviceTime', 5) * defaultServiceTime;
    //
    // const activityEta = _.get(activity, 'eta');
    // const activityEtd = _.get(activity, 'etd', activityEta + activityServiceTimeInMili);
    //

    let relationIcon;
    const relationDivs = document.createElement('div');

    const warningsDiv = document.createElement('div');
    let warnIcon;

    let spanRow;

    let jobProgramTypeAlias = '';
    let activityAccountName = activity.accountName;
    const groupAccountName = activity.stopActivities?.length ? (activity.stopActivities[0].accountName || activity.accountName) : activity.accountName;
    if ((activity?.jobId || activity?.jobIds) && (activity.type !== 'START') && (activity.type !== 'END')) {
      const jobIds = activity.jobIds || [activity.jobId]
      jobIds.forEach((i) => {
        const job = this.jobsMap?.[i];
        const jobProgramType = job?.pricePlanProgramType || '';
        if (jobProgramType && this.programTypeAliasMap?.[jobProgramType]) {
          jobProgramTypeAlias = jobProgramTypeAlias + this.programTypeAliasMap[jobProgramType];
        } else if (jobProgramType) {
          jobProgramTypeAlias = jobProgramTypeAlias + jobProgramType.charAt(0);
        }

        activityAccountName = job?.accountDocumentName || job?.accountName || activityAccountName;
      })
    }
    jobProgramTypeAlias = jobProgramTypeAlias || '';
    activityAccountName = activityAccountName || '---';


    return isGroup ?
      '<div class="item-body br-caption-1 font-weight-800" style="background-color: ' + color + '">'
      + '<span class="text">' + escapeHtml(jobProgramTypeAlias) + '(' + activity.stopActivities.length + ') ' + activity.indexInRoute + ' ' + escapeHtml(groupAccountName || '---') + '</span>'
      + (spanRow ? spanRow : '')
      + '</div>'
      + (relationIcon ? relationIcon.outerHTML : '')
      + (warnIcon ? warnIcon.outerHTML : '') :
      '<div class="item-body br-caption-1 font-weight-300" style="background-color: ' + color + '">'
      + '<span class="text">' + '<span class="font-weight-600">' + escapeHtml(jobProgramTypeAlias) + '</span>' + ' ' + escapeHtml(activityAccountName) + '</span>'
      + (spanRow ? spanRow : '')
      + '</div>'

    // return isGroup ? '<span class="br-caption-2">' + this.$filter('translate')(itemType.charAt(0)) + '(' + activity.stopActivities.length + ') ' + activity.indexInRoute + '</span>'
    //   + (relationIcon ? relationIcon.outerHTML : '')
    //   + (warnIcon ? warnIcon.outerHTML : '') :
    //   '<span class="br-caption-2">' + this.$filter('translate')(itemType.charAt(0)) + ' ' + (activity.indexInRoute) + '</span>'
    //   + (relationIcon ? relationIcon.outerHTML : '')
    //   + (warnIcon ? warnIcon.outerHTML : '');
  }

  private _getStartEndTooltip(activity) {
    const routeColor = this._getRouteColor(activity.routeId);
    const stopType = activity.type;
    // const depotId = _.get(activity, 'depotId');

    return '<div class="header-container">'
      + '<span class="br-body-2 font-weight-600" style="color: ' + routeColor + '">' + this.$filter('translate')(stopType) + '</span>'
      + '</div>'
      // + '<div class="info-row">'
      // + this.$depotIcon.outerHTML
      // + '<span class="br-body-2 margin-left-5">' + _.get(this.depotsMap, depotId + '.name', '---') + '</span>'
      // + '</div>'
      + '<div class="info-row">'
      + this.$locationIcon.outerHTML
      + '<span class="br-body-2 margin-left-5">' + escapeHtml(this.$filter('bringozAddress')(activity.address)) + '</span>'
      + '</div>'
  }

  // private _getStopTooltip(activity) {
  //
  //
  //   const routeColor = this._getRouteColor(activity.routeId);
  //   const serviceTime = activity.serviceTime;
  //   const depotId = _.get(activity, 'depotId');
  //   const originalTimeWindow = this.$filter('timeWindow')(activity);
  //   const activityType = activity.type;
  //
  //   const defaultServiceTime = 60000;
  //   const activityServiceTimeInMili = _.get(activity, 'serviceTime', 5) * defaultServiceTime;
  //   const activityEta = _.get(activity, 'eta');
  //   const activityEtd = _.get(activity, 'etd', activityEta + activityServiceTimeInMili);
  //
  //   const activityPurpose = activity.stopType || '---';
  //   const isStop = _.isEqual(activity.type, 'STOP');
  //   const isGroup = _.isEqual(activity.type, 'GROUP');
  //   const isPoint = (!isStop && !isGroup && !_.get(activity, 'serviceTime'));
  //   const stopTimeWindow = this.$filter('timeWindow')({notBefore: activityEta, notAfter: activityEtd});
  //   const barcodes = this.planningCommonService.getBarcodesString(activity);
  //   const activityPackageTotals = this.planningCommonService.getActivityPackageTotals(activity);
  //   const spotsTotal = this.$filter('orderSpots')(activity.packages);
  //   const relationDivs = document.createElement('div');
  //   let tripNumberRow;
  //
  //
  //   let relationIcon;
  //
  //
  //   const warningsDiv = document.createElement('div');
  //   let warnIcon;
  //
  //
  //   if (!!activity?.tripNumber) {
  //     tripNumberRow = '<div class="info-row">'
  //       + this.$tripIcon.outerHTML
  //       + '<span class="br-body-2">' + activity.tripNumber + '</span>'
  //       + '</div>'
  //   }
  //
  //
  //   const activityAddress = _.get(activity, 'stopActivities[0].address', activity.address);
  //   const activityAccount = _.get(activity, 'stopActivities[0].accountName', activity.accountName) || '---';
  //   const tooltipHeader = (isGroup ? this.$filter('translate')('Multi') + ' ' : '') + activityPurpose;
  //
  //   return '<div class="header-container">'
  //     + '<span class="br-body-2 font-weight-600" style="color: ' + routeColor + '">' + tooltipHeader + '</span>'
  //     + (relationIcon ? relationIcon.outerHTML : '')
  //     + relationDivs.outerHTML
  //     + '</div>'
  //     // + '<div class="info-row">'
  //     // + this.$locationIcon.outerHTML
  //     // + '<span class="br-body-2 margin-left-5">' + this.$filter('bringozAddress')(activityAddress) + '</span>'
  //     // + '</div>'
  //     + '<div class="info-row">'
  //     + this.$accountIcon.outerHTML
  //     + '<span class="br-body-2 margin-left-5">' + activityAccount + '</span>'
  //     + '</div>'
  //     // + '<div class="info-row">'
  //     // + this.$depotIcon.outerHTML
  //     // + '<span class="br-body-2 margin-left-5">' + _.get(this.depotsMap, depotId + '.name', '---') + '</span>'
  //     // + '</div>'
  //     // + '<div class="info-row">'
  //     // + $skillsIcon.outerHTML
  //     // + skillsDiv.outerHTML
  //     // + '</div>'
  //     + '<div class="info-row">'
  //     + this.$originalTimeWindowIcon.outerHTML
  //     // + '<span class="br-body-2 margin-left-5">' + this.$filter('bringozDate')(activity.notBefore) + '</span>'
  //     + '<span class="br-body-2">' + originalTimeWindow + '</span>'
  //     + '</div>'
  //     + '<div class="info-row">'
  //     + this.$timeWindowIcon.outerHTML
  //     + '<span class="br-body-2 margin-right-10">' + stopTimeWindow + '</span>'
  //     // + this.$serviceTimeIcon.outerHTML
  //     // + '<span class="br-body-2 margin-left-5">' + this.$filter('bringozTimeConvert')(serviceTime, false, true) + '</span>'
  //     + '</div>'
  //     + tripNumberRow
  //     // + warningsDiv.outerHTML
  //     + '<div class="info-row margin-right-5">'
  //     + this.$packageIcon.outerHTML
  //     + '<span class="br-body-2 margin-right-5">' + _.get(activityPackageTotals, 'packages', '---') + '</span>'
  //     + this.$weightIcon.outerHTML
  //     + '<span class="br-body-2 margin-right-5">' + _.get(activityPackageTotals, 'weight', '---') + '</span>'
  //     + this.$volumeIcon.outerHTML
  //     + '<span class="br-body-2 margin-right-5">' + _.get(activityPackageTotals, 'volume', '---') + '</span>'
  //     + this.$spotsIcon.outerHTML
  //     + '<span class="br-body-2">' + spotsTotal + '</span>'
  //     + '</div>'
  //   // + '<div class="info-row">'
  //   // + this.$barcodeIcon.outerHTML
  //   // + '<span class="br-body-2 margin-left-5">' + barcodes + '</span>'
  //   // + '</div>'
  // }

  private _getStopTooltip(activity, route, activityAnalysis?: VisitScheduleRouteActivityAnalysisModel, routeAnalysis?: VisitScheduleRouteAnalysisModel) {

    const routeColor = !!this.agentColorMap ? this.agentColorMap[route.resource.agentId] : this._getRouteColor(activity.routeId);

    const serviceTime = activity.detailedServiceTime?.generatedTotalTime;
    const depotId = _.get(activity, 'depotId');
    const originalTimeWindow = this.$filter('timeWindow')(activity);
    let originalTimeWindowUserTimezone = '';

    if (!!this.timezoneOffset) {
      const timeWindow = this.$filter('timeWindow')(activity, this.userZoneId);
      originalTimeWindowUserTimezone = '<div class="info-row">'
        + this.$timeZoneIcon.outerHTML
        + '<span class="br-body-2">' + timeWindow + '</span>'
        + '</div>'
    }
    // const
    const activityType = activity.type;

    const defaultServiceTime = 60000;
    const activityServiceTimeInMili = _.get(activity, 'serviceTime', 5) * defaultServiceTime;
    const activityEta = _.get(activity, 'eta');
    const activityEtd = _.get(activity, 'etd', activityEta + activityServiceTimeInMili);

    const activityPurpose = activity.stopType || '---';
    const isStop = _.isEqual(activity.type, 'STOP');
    const isGroup = _.isEqual(activity.type, 'GROUP');
    // const isPoint = (!isStop && !isGroup && !_.get(activity, 'serviceTime'));
    const stopTimeWindow = this.$filter('timeWindow')({notBefore: activityEta, notAfter: activityEtd});

    const strategicPriority = isGroup ?
      activity?.stopActivities?.[0]?.accountReference?.strategicPriority :
      activity.accountReference?.strategicPriority;

    const segment = _.isNil(strategicPriority?.segment) ? '' : `${strategicPriority.segment}`;


    let stopTimeWindowUserTimezone = '';

    let jobProgramTypeAlias = '';
    if ((activity?.jobId || activity?.jobIds) && (activity.type !== 'START') && (activity.type !== 'END')) {
      const jobIds = activity.jobIds || [activity.jobId]
      jobIds.forEach((i) => {
        const job = this.jobsMap?.[i];
        const jobProgramType = job?.pricePlanProgramType || '';
        if (jobProgramType && this.programTypeAliasMap?.[jobProgramType]) {
          jobProgramTypeAlias = jobProgramTypeAlias + this.programTypeAliasMap[jobProgramType];
        } else if (jobProgramType) {
          jobProgramTypeAlias = jobProgramTypeAlias + jobProgramType.charAt(0);
        }
      })
      // const job = this.jobsMap?.[activity.jobIds?.length ? activity.jobIds[0] : activity.jobId];
      // const jobProgramType = job?.pricePlanProgramType || '';
      // if (jobProgramType && this.programTypeAliasMap?.[jobProgramType]) {
      //   jobProgramTypeAlias = this.programTypeAliasMap[jobProgramType];
      // } else if (jobProgramType) {
      //   jobProgramTypeAlias = jobProgramType.charAt(0);
      // }
    }

    const details: VisitScheduleActivityDetailsModel = route.activityDetails?.find((ad: VisitScheduleActivityDetailsModel) => {
      return ad.activityId === activity.id;
    })

    let branchesRow = '';
    if (!!details?.branchReferences) {
      branchesRow = '<div class="info-row">'
        + this.$branchIcon.outerHTML
        + '<span class="br-body-1 margin-right-10">' + escapeHtml(this._getNames(_.map(details.branchReferences, 'name'), 3)) + '</span>'
        + '</div>'
    }

    let programTypeRow = '';
    if (!!jobProgramTypeAlias) {
      programTypeRow = '<div class="info-row">'
        + this.$programIcon.outerHTML
        + '<span class="br-body-2 activity-program-type">' + escapeHtml(jobProgramTypeAlias) + '</span>'
        + '</div>'
    }

    if (!!this.timezoneOffset) {
      const timeWindow = this.$filter('timeWindow')({notBefore: activityEta, notAfter: activityEtd}, this.userZoneId);
      stopTimeWindowUserTimezone = '<div class="info-row">'
        + this.$timeZoneIcon.outerHTML
        + '<span class="br-body-2">' + timeWindow + '</span>'
        + '</div>'
    }

    let travelTimeRow = '';
    if (activity.travelTimeFromLastStopMillis) {
      travelTimeRow = '<div class="info-row">'
        + '<span class="br-body-2 margin-left-5 margin-right-5"> ' + this.$filter('translate')('Travel Time') + '</span>'
        + '<span class="br-body-2">' + this.$filter('bringozTimeConvert')(Math.abs(activity.travelTimeFromLastStopMillis), true) + '</span>'
        + '</div>'
    }

    let priorityRow = '';
    if (segment) {
      priorityRow = '<div class="info-row">'
        + this.$priorityIcon.outerHTML
        + '<span class="br-body-2"> ' + this.$filter('translate')('Segment') + ': ' + segment + '</span>'
        + '</div>'
    }

    let idleTimeRow = '';
    if (activity.notBefore > activityEta) {
      idleTimeRow = '<div class="info-row">'
        + '<span class="br-body-2 margin-left-5 margin-right-5"> ' + this.$filter('translate')('Idle Time') + '</span>'
        + '<span class="br-body-2">' + this.$filter('bringozTimeConvert')(Math.abs(activityEta - activity.notBefore), true) + '</span>'
        + '</div>'
    }

    let serviceTimeRow = '';
    if (!!serviceTime) {
      serviceTimeRow = '<div class="info-row">'
        + '<span class="br-body-2 margin-left-5 margin-right-5"> ' + this.$filter('translate')('Service Time') + '</span>'
        + '<span class="br-body-2">' + this.$filter('bringozTimeConvert')(serviceTime, true) + '</span>'
        + '</div>'
    }

    let risksSection = '';
    if (activityAnalysis?.risks?.length || routeAnalysis?.risks?.length) {
      risksSection = '<div class="risks-container">'
      // + '<span class="br-body-3 risks-header">' + this.$filter('translate')('Risks') + ':</span>'

      activityAnalysis?.risks?.forEach((r) => {
        risksSection += '<div class="info-row">'
          + this.$riskIcon.outerHTML
          + '<span class="br-body-2"> ' + this.$filter('translate')('VISIT_SCHEDULE_RISK.ROUTE_ACTIVITY.' + r) + '</span>'
          + '</div>'
      })

      routeAnalysis?.risks?.forEach((r) => {
        risksSection += '<div class="info-row">'
          + this.$riskIcon.outerHTML
          + '<span class="br-body-2"> ' + this.$filter('translate')('VISIT_SCHEDULE_RISK.ROUTE.' + r) + '</span>'
          + '</div>'
      })

      risksSection += '</div>';
    }

    // const barcodes = this.planningCommonService.getBarcodesString(activity);
    const activityPackageTotals = this.planningCommonService.getActivityPackageTotals(activity);
    // const spotsTotal = this.$filter('orderSpots')(activity.packages);
    // const relationDivs = document.createElement('div');
    // let tripNumberRow;
    //
    //
    // const warningsDiv = document.createElement('div');
    // let warnIcon;

    // const skillsDiv = document.createElement('div');
    // const skills = _.get(ctrl.jobsMap[activity.jobId], 'skills', []);
    //
    // if (skills && skills.length) {
    //   _.forEach(skills, function(s, i) {
    //     const skill = document.createElement('div');
    //     skill.classList.add('skill-tag');
    //
    //     const skillText = document.createElement('span');
    //     skillText.innerHTML = _getTranslatedSkill(s);
    //     skill.appendChild(skillText);
    //     skillsDiv.appendChild(skill);
    //   })
    // }


    const activityAddress = _.get(activity, 'stopActivities[0].address', activity.address);
    const activityAccount = _.get(activity, 'stopActivities[0].accountName', activity.accountName) || '---';
    const tooltipHeader = (isGroup ? this.$filter('translate')('Multi') + ' ' : '') + activityPurpose;

    return '<div class="header-container">'
      + '<span class="br-body-2 font-weight-600" style="color: ' + routeColor + '">' + tooltipHeader + '</span>'
      + '</div>'
      // + '<div class="info-row">'
      // + this.$locationIcon.outerHTML
      // + '<span class="br-body-2 margin-left-5">' + this.$filter('bringozAddress')(activityAddress) + '</span>'
      // + '</div>'
      + '<div class="info-row">'
      + this.$accountIcon.outerHTML
      + '<span class="br-body-2">' + escapeHtml(activityAccount) + '</span>'
      + '</div>'
      + branchesRow
      // + '<div class="info-row">'
      // + this.$depotIcon.outerHTML
      // + '<span class="br-body-2 margin-left-5">' + _.get(this.depotsMap, depotId + '.name', '---') + '</span>'
      // + '</div>'
      // + '<div class="info-row">'
      // + $skillsIcon.outerHTML
      // + skillsDiv.outerHTML
      // + '</div>'
      + '<div class="info-row">'
      + this.$originalTimeWindowIcon.outerHTML
      // + '<span class="br-body-2 margin-left-5">' + this.$filter('bringozDate')(activity.notBefore) + '</span>'
      + '<span class="br-body-2">' + originalTimeWindow + '</span>'
      + originalTimeWindowUserTimezone
      + '</div>'
      + '<div class="info-row">'
      + this.$timeWindowIcon.outerHTML
      + '<span class="br-body-2 margin-right-10">' + stopTimeWindow + '</span>'
      + stopTimeWindowUserTimezone
      + '</div>'
      + travelTimeRow
      + idleTimeRow
      + serviceTimeRow
      + programTypeRow
      + priorityRow
      + risksSection
    // + tripNumberRow
    // + warningsDiv.outerHTML
    // + '<div class="info-row margin-right-5">'
    // + this.$packageIcon.outerHTML
    // + '<span class="br-body-2 margin-right-5">' + _.get(activityPackageTotals, 'packages', '---') + '</span>'
    // + this.$weightIcon.outerHTML
    // + '<span class="br-body-2 margin-right-5">' + _.get(activityPackageTotals, 'weight', '---') + '</span>'
    // + this.$volumeIcon.outerHTML
    // + '<span class="br-body-2 margin-right-5">' + _.get(activityPackageTotals, 'volume', '---') + '</span>'
    // // + this.$spotsIcon.outerHTML
    // // + '<span class="br-body-2">' + spotsTotal + '</span>'
    // + '</div>'
    // + '<div class="info-row">'
    // + this.$barcodeIcon.outerHTML
    // + '<span class="br-body-2 margin-left-5">' + barcodes + '</span>'
    // + '</div>'
  }

  public _mapRoutesToActivityItems(routes) {
    return _.flatMap(routes, (route) => {
      const color = this._getRouteColor(route.id);
      const activities = route.activities.filter(a => (a.type !== 'START') && (a.type !== 'END'));
      return this._getItemsData(route, activities, color);
    });
  }

  private _getItemsData(route, activities, color) {
    // var stopIndex = 0;

    const resourceRef = _.find(this.resources, (r) => {
      return r.id === route.resource.id;
    })

    const routeAnalysis = this.analysis?.routes.find((r) => {
      return r.routeId === route.id;
    })

    return _.map(activities, (activity, index) => {
      const defaultServiceTime = 60000;
      const activityServiceTimeInMili = _.get(activity, 'serviceTime', 5) * defaultServiceTime;
      const activityEta = _.get(activity, 'eta');
      const activityEtd = _.get(activity, 'etd', activityEta + activityServiceTimeInMili);

      const resourceStartTime = _.get(route.resource, 'startTime');
      const resourceStartEndTime = _.get(route.resource, 'endTime');

      const routeVisitScheduleDay = this.visitScheduleDays.find(vsd => vsd.id === route.visitScheduleDayId);

      const activityAnalysis = (routeAnalysis?.activities || []).find((a) => {
        return a.activityId === activity.id;
      })

      const hasIdleTime = activity.notBefore > activityEta;

      let color;

      if (resourceRef?.disabled || hasIdleTime || (activityAnalysis?.risks?.length || routeAnalysis?.risks?.length)) {
        color = '#D52424';
      } else {
        color = (route.status === 'DISPATCHED' || isVisitScheduleDayDispatched(routeVisitScheduleDay)) ? '#A3A3A3' : (this.moment(activityEta).isSameOrAfter(this.moment(resourceStartTime)) && this.moment(activityEtd).isSameOrBefore(this.moment(resourceStartEndTime)) ? '#5094EB' : '#D52424');
      }

      const activityPurpose = activity.stopType || 'Dropoff';
      const isStop = _.isEqual(activity.type, 'STOP');
      const isGroup = _.isEqual(activity.type, 'GROUP');
      const isPoint = (!isStop && !isGroup);


      // if (isStop || isGroup) {
      //   stopIndex++;
      // }

      function _getStopDependenciesForGroup(map) {
        const stopActivityIds = _.map(activity.stopActivities, 'stopId');
        const allArrays = _.chain(map)
          .pickBy((value, key) => {
            return _.includes(stopActivityIds, key);
          })
          .toArray()
          .value();
        return _.spread(_.union)(allArrays);
      }

      return {
        ref: activity,
        id: activity.id,
        // resourceId: route.resource.id,
        start: this.moment(activityEta),
        end: this.moment(activityEtd || (activityEta + activityServiceTimeInMili)),
        group: route.resource.resourceHolderId,
        routeId: route.id,
        accountName: activity.accountName,
        activityId: activity.id,
        stopId: activity.stopId,
        stopIds: _.get(activity, 'stopIds', []), // For Groups Only
        jobIds: activity.jobId ? [activity.jobId] : _.get(activity, 'jobIds', []),
        purpose: activityPurpose,
        activityType: activity.type,
        routeColor: color,
        routeStatus: route.status,
        risks: activityAnalysis?.risks,
        // relatedRoutes: relatedRoutes || [],
        // relatedStops: relatedStops || [],
        // warnings: warnings || [],
        point: (!isStop && !isGroup) ? 'point' : 'box',
        title: isPoint ? this._getStartEndTooltip(activity) :
          this._getStopTooltip(activity, route, activityAnalysis, routeAnalysis),
        content: isPoint ?
          this._getStartEndPointsContent(activity, color) :
          this._getStopContent(activity, color),
        style: `background-color: white; border-color: ${color}; color: white;`,
        // style: 'background-color: ' + `${color}30` + '; color: white',
        className: isPoint ? 'point' : (isGroup ? 'group' : 'stop'),
        itemType: 'TASK',
        selectable: true,
        editable: {
          add: false,                                                                // add new items by double tapping
          updateTime: !route.locked && !isVisitScheduleDayDispatched(routeVisitScheduleDay) && !this.visitPlan.hasNotSyncedChanges,        // drag items horizontally
          updateGroup: (route.status === 'DISPATCHED' || route.status === 'PARTIAL_DISPATCHED' || isVisitScheduleDayDispatched(routeVisitScheduleDay) || this.visitPlan.hasNotSyncedChanges) ? false : !route.locked,
        }
      }
    });
  }

  private _getGroupData(route, color) {

    const firstActivity: any = _.head(route.activities);
    const lastActivity: any = _.last(route.activities);

    const resourceSource = _.get(route, 'resource.source');
    const resourceName = resourceSource === 'AgentSchedule' ? _.get(route, 'resource.agentName')
      : (_.get(route, 'resource.allocationName') || _.get(route, 'resource.vehicleName', '---'));
    // const firstActivityDepotName = _.get(this.depotsMap, firstActivity.depotId + '.name', '---');
    // const lastActivityDepotName = _.get(this.depotsMap, lastActivity.depotId + '.name', '---');

    const routeIndex = _.findIndex(this.routes, (r: any) => {
      return r.id === route.id;
    })

    const maxVolume = route.resource?.capacity?.dimensions ?
      (route.resource.capacity.dimensions.height * route.resource.capacity.dimensions.width * route.resource.capacity.dimensions.length) : undefined;

    return {
      id: route.id,
      order: routeIndex,
      locked: route.locked,
      color: color || 'black',
      status: route.status,
      group: route.resource.agentId,
      resourceName: resourceName,
      totalIncome: _.get(route, 'totals.totalIncome'),
      minimumIncome: _.get(route, 'resource.routeIncomePreferences.minimumRouteIncome'),
      maximumIncome: _.get(route, 'resource.routeIncomePreferences.maximumRouteIncome'),
      agentName: _.get(route, 'resource.agentName', '---'), // missing on resource data
      allocationSkills: _.get(route, 'resource.allocationSkills', []),
      agentSkills: this._getTranslatedAgentSkills(_.get(route, 'resource.allocationSkills', []), true), // missing on resource type VEHICLE data - talk to eliav
      vehicle: _.get(route, 'resource.vehicleName', '---'),
      load: this.$filter('bringozWeight')(route.totals.totalLoad, true),
      value: this.$filter('bringozPrice')(route.totals.value),
      cost: this.$filter('bringozPrice')(route.totals.cost),
      distance: this.$filter('bringozDistance')(route.totals.totalDistanceMeter),
      stops: route.totals.totalStopsCount || '---',
      jobs: route.totals.totalJobsCount || '---',
      weightPercentage: route.weightPercentage,
      volumePercentage: route.capacityPercentage,
      weight: _.round(_.get(route.totals, 'totalLoad'), 1),
      maxWeight: _.round(_.get(route, 'resource.capacity.weight'), 1) || this.$infinitySymbol,
      volume: _.round(_.get(route.totals, 'totalVolume'), 1),
      maxVolume: _.round(maxVolume, 1) || this.$infinitySymbol,
      packagesCount: _.get(route.totals, 'totalPackagesCount', '---'),
      maxPackagesCount: _.get(route, 'resource.capacity.numberOfPackages', this.$infinitySymbol),
      spots: _.round(_.get(route.totals, 'totalSpots'), 1) || 0,
      maxSpots: _.round(_.get(route, 'resource.capacity.numberOfSpots'), 1) || this.$infinitySymbol,
      // alerts: routeWarnings || [],
      duration: this.$filter('translate')('Duration') + ': ' + this.$filter('bringozTimeConvert')(route.totals.totalTimeSec),
      timeWindow: this.$filter('timeWindow')({
        notBefore: _.get(firstActivity, 'eta'),
        notAfter: _.get(lastActivity, 'eta')
      }),
      eta: _.get(firstActivity, 'eta'),
      className: `group-row br-caption-2 ${route.locked ? 'locked' : ''}`,
      enabled: true, // For Eye icon (show or not in map)
      visible: true, // For filtering the displayed routes in table
      // relatedRoutes: relatedRoutes || [],
      // startDepot: firstActivityDepotName,
      // endDepot: lastActivityDepotName
    };
  }

  private _getRouteColor(routeId) {
    const route = _.find(this.routes, function (r) {
      return r.id === routeId;
    })
    return this.planningCommonService.getRouteColor(route);
  }

  _getGroupsData(agents) {
    const agentsGroups = [];

    _.forEach(agents, (a, index) => {
      agentsGroups.push(this._getAgentsGroup(a, index));
    })

    return agentsGroups;
  }

  private redrawGroupTemplate() {
    const updatedGroups = this._getGroupsData(this.agents)
    this.groupsDataSet.update(updatedGroups);
  }

  private _getTranslatedSkills(skills, isFirstLetterOnly?) {
    return _.map(skills, (s) => {
      let text;

      if (this.siteSkills[s].custom) {
        text = this.siteSkills[s].name;
      } else {
        text = this.$filter('translate')('SKILLS.' + this.siteSkills[s].name);
      }
      return isFirstLetterOnly ? text.charAt(0) : text;
    });
  }

  private _getScheduleBreaksItemsData(schedules) {
    let items = [];

    _.forEach(schedules, (s) => {
      _.forEach(s.scheduleExtraData, (extraData) => {
        _.forEach(extraData.breaks, (b) => {
          const exceptions = _.get(s, 'agentSchedule.schedule.exceptions', []);

          if (exceptions.length) {
            const isException = _.find(exceptions, (e) => {
              return this.moment(extraData.eventDate).isSame(this.moment(e), 'date');
            })
            if (isException) {
              return;
            }
          }
          items.push(this._getScheduleBreakItemData(s, b, s.agentId, s.id)) //AgentScheduleBreak
        })
      })
    });

    return items;
  }

  private _getResourceItemsData(resources) {
    let items = [];

    _.forEach(resources, (resource) => {
      // Skip archived Leave schedules
      if (resource.scheduleType === 'Leave' && resource.scheduleArchived) {
        return;
      }
      items.push(this._parseResourceToItem(resource));
    });

    return items;
  }

  private _getResourceRisksBackgroundItemsData(resourceHolders: VisitScheduleResourceHolderAnalysisModel[]) {
    const entriesByHolderDay: { [key: string]: { analysis: VisitScheduleResourceAnalysisModel, resource: VisitScheduleResourceModel }[] } = {};

    // resourceHolders (Agents) — an agent may have several resources (availabilities) on the same day.
    // The timeline doesn't stack items, so they're merged into a single day item to avoid overlapping icons.
    _.forEach(resourceHolders, (rh) => {
      _.forEach(rh.resourceAnalysis, (a: VisitScheduleResourceAnalysisModel) => {
        const resourceRef = this.resources?.find((r) => {
          return a.resourceId === r.id;
        });
        if (!!resourceRef) {
          // Keyed exactly like the item's placement (group + day of startTime) so merged resources are the ones that would overlap
          const key = `${resourceRef.resourceHolderId}-${this.moment(resourceRef.startTime).startOf('day').valueOf()}`;
          (entriesByHolderDay[key] = entriesByHolderDay[key] || []).push({ analysis: a, resource: resourceRef });
        }
      })
    });

    return _.map(entriesByHolderDay, (entries, key) => this._getResourceRisksBackgroundItem(key, entries));
  }

  private _getResourceRisksBackgroundItem(key: string, entries: { analysis: VisitScheduleResourceAnalysisModel, resource: VisitScheduleResourceModel }[]) {
    // const tooltip = analysis.risks.map(r => this.$filter('translate')(`VISIT_SCHEDULE_RISK.RESOURCE.${r}`)).join("<br>");

    let tooltip = '';

    entries.forEach(({ analysis }, entryIndex) => {
      analysis.risks?.forEach((r, index) => {
        const riskData: VisitScheduleResourceAnalysisRisksDataModel[] = _.get(analysis.risksData, r);
        tooltip += '<div class="info-row padding-0 ' + (index > 0 || entryIndex > 0 ? 'margin-top-5' : '') + '">'
          + `<span class="br-body-1 resource-risk ${r}">` + this.$filter('translate')(`VISIT_SCHEDULE_RISK.RESOURCE.${r}`) + '</span>'
          + '</div>';

        if (!!riskData?.length) {
          riskData.forEach((d) => {
            const duration = (r === 'OccupiedPublished' && d.startTime && d.endTime) ?
              this.$filter('serviceTime')(d.endTime - d.startTime) :
              '';
            tooltip += '<div class="info-row padding-0">'
              + '<span class="br-body-1">' + this.$filter('translate')(`VISIT_SCHEDULE_RISK.RESOURCE_DATA`, { visitPlanName: d.visitPlanName, creatorName: d.visitPlanCreator?.name}) + (duration ? ' - ' + duration : '') + '</span>'
              + '</div>'
          })
        }
      })
    });

    const resource = entries[0].resource;
    const conflictEntries = entries.filter(e => !!e.analysis.risks?.includes('OccupiedPublished'));
    const hasOtherRisks = entries.some(e => e.analysis.risks?.some(r => r !== 'OccupiedPublished'));
    const isPublishedConflict = conflictEntries.length > 0;
    const isSolvedConflict = isPublishedConflict && conflictEntries.every(e => this._isConflictSolved(e.resource));
    const content = (hasOtherRisks ? this.$riskIcon.outerHTML : '')
      + (isPublishedConflict
        ? `<span data-bz-action="open-availability-conflicts" data-bz-id="${resource.resourceHolderId}">${this._getConflictIconMarkup(isSolvedConflict)}</span>`
        : '');

    return {
      id: `risks-${key}`,
      start: this.moment(resource.startTime).startOf('day'),
      end: this.moment(resource.startTime).endOf('day'),
      // group: resourceHolder.resourceHolderId,
      group: resource.resourceHolderId,
      type: 'range',
      itemType: 'RESOURCE_RISKS',
      // type: 'point',
      content,
      title: tooltip,
      className: 'resource-risks-background' + (isPublishedConflict ? ' clickable-risk' : '')
    }
  }

  // A published-route conflict is "solved" once the agent has a valid (non-disabled) availability
  // assigned on the same day as the flagged one — regardless of that resource's own analysis risks.
  private _isConflictSolved(resource: VisitScheduleResourceModel): boolean {
    return (this.resources || []).some(r =>
      r.id !== resource.id
      && r.resourceHolderId === resource.resourceHolderId
      && r.visitScheduleDayId === resource.visitScheduleDayId
      && r.disabled === false
    );
  }

  // Single source of markup for the clickable conflict icon — color is driven purely by the
  // "solved" modifier class, not by swapping between separate icon instances.
  private _getConflictIconMarkup(solved: boolean): string {
    return `<svg class="bringoz-icon-small calendar-conflict-icon${solved ? ' solved' : ''}" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">`
      + '<path d="M7 11H9V13H7V11ZM7 15H9V17H7V15ZM11 11H13V13H11V11ZM11 15H13V17H11V15ZM15 11H17V13H15V11ZM15 15H17V17H15V15Z"/>'
      + '<path d="M5 22H19C20.103 22 21 21.103 21 20V8V6C21 4.897 20.103 4 19 4H17V2H15V4H9V2H7V4H5C3.897 4 3 4.897 3 6V8V20C3 21.103 3.897 22 5 22ZM19 8L19.001 20H5V8H19Z"/>'
      + '</svg>';
  }

  private _onClicked() {
    const deferred = this.$q.defer();
    deferred.resolve();
    return deferred.promise;
  }

  private _getTranslatedAgentSkills(skills, isFirstLetterOnly) {
    return _.map(skills, (s) => {
      return this._getTranslatedSkill(s, isFirstLetterOnly)
    });
  }

  private _getTranslatedSkill(skill, isFirstLetterOnly) {
    const text = this.$filter('translate')('SKILLS.' + skill);
    return isFirstLetterOnly ? text.charAt(0) : text;
  }

  private _addRoutesBackgroundToTimeline(routes) {
    let backgroundItems = [];

    _.forEach(routes, (r) => {
      backgroundItems = backgroundItems.concat(this._getRouteBackgroundItem(r));
    });

    this.itemsDataSet.add(_.concat(backgroundItems));
  }

  //
  // private _getRouteBackgroundItem(route) {
  //   return {
  //     id: route.rid,
  //     ref: route,
  //     routeId: route.rid,
  //     start: this.moment(route.notBefore),
  //     end: this.moment(route.notAfter),
  //     group: _.get(route, 'agentId'),
  //     type: 'background',
  //     itemType: 'ROUTE',
  //     className: 'route-background'
  //   }
  // }

  private _setExpandedGroupsRoutes(isEnabled, doReorder?) {
    const updatedGroups = [];

    this.groupsDataSet.forEach((group) => {
      group.showNested = isEnabled;
      if (doReorder) {
        group.order = _.findIndex(this.agents, (a: any) => {
          return a.id === group.id;
        })
      }
      updatedGroups.push(group);
    });

    this.groupsDataSet.update(updatedGroups);
  }

  private _clearScheduleItems() {
    const itemsToClear = [];
    this.itemsDataSet.forEach((item) => {
      if (item.itemType === 'RESOURCE') {
        itemsToClear.push(item.id);
      }
    });
    this.itemsDataSet.remove(itemsToClear);
  }

  private _clearScheduleRisksBackgroundItems() {
    const itemsToClear = [];
    this.itemsDataSet.forEach((item) => {
      if (item.itemType === 'RESOURCE_RISKS') {
        itemsToClear.push(item.id);
      }
    });
    this.itemsDataSet.remove(itemsToClear);
  }

  private _updateTimelineTasks(taskItems) {
    const itemsToUpdate = [];

    this.itemsDataSet.forEach((item) => {
      if (_.includes(_.map(taskItems, 'id'), _.get(item, 'id'))) {
        itemsToUpdate.push(item.id);
      }
      // if (!item.itemType === 'ROUTE' && _.includes(tasksIds, item.id)) {
      //   itemsToUpdate.push(item.id);
      // }
    });
    this.itemsDataSet.update(_.filter(taskItems, (t) => {
      return _.includes(itemsToUpdate, t.id)
    }));
    // itemsDataSet.remove(itemsToUpdate);
    // timeline.setItems(itemsToUpdate);
  }

  private _getTasksItemsData(tasks) {
    return _.map(tasks, (task) => {
      const agentId = task.agentId;
      const routeColor = this._getColorByAgentId(agentId);
      const index = _.get(task, 'routeAnalysis.daySequence');

      const taskPurpose = task.taskSpec.purpose;
      const taskServiceTime = _.get(task, 'routeAnalysis.serviceTime');
      const isPoint = _.isEqual(task.taskType, 'Internal');
      const isBundle = _.isEqual(task.taskType, 'BundledStopover');
      const isBreak = _.isEqual(taskPurpose, 'Break');
      let taskEta = _.get(task, 'routeAnalysis.eta');
      const taskEtd = _.get(task, 'routeAnalysis.etd', (taskEta + taskServiceTime));
      const relations = _.get(task, 'relations', []);
      const taskNotBefore = _.get(task, 'taskSpec.notBefore');
      const updatedAt = _.get(task, 'updatedAt');

      if (taskEta < taskNotBefore) {
        taskEta = taskNotBefore
      }

      const taskEtaWindow = this.$filter('timeWindow')({notBefore: taskEta, notAfter: taskEtd});


      let className = isPoint ? 'internal route-item' : (isBundle ? 'bundle route-item' : (isBreak ? 'task route-item break' : 'task route-item'))
      let style = 'color: white;';
      className += ` ${task.status}`;


      if (isBundle) {
        style += ' box-shadow: 2px -2px 0px ' + this.commonsService.lightenDarkenColor(routeColor, -35) + ';';
      }

      return {
        ref: task,
        id: task.id,
        itemType: 'TASK',
        status: task.status,
        // id: route.rid + task.id,
        start: this.moment(taskEta),
        end: this.moment(taskEtd),
        startTime: this.moment(taskEta),
        endTime: this.moment(taskEtd),
        purpose: taskPurpose,
        taskIdList: _.get(task, 'taskIdList'), // For Bundle Only
        point: isPoint ? 'point' : 'box',
        taskType: task.taskType,
        serviceId: task.serviceId,
        serviceIds: task.bundleServiceIdList,
        group: agentId,
        agentId: agentId,
        resourceId: agentId,
        routeId: task.routeId,
        taskId: task.id,
        updatedAt: updatedAt,
        className: className,
        editable: {
          add: false,                          // add new items by double tapping
          updateTime: false,                // drag items horizontally
          updateGroup: true,              // drag items from one group to another
          remove: false                 // delete an item by tapping the delete button top right
        },
        // subgroup: route.rid,
        title: this.bringozTimelineService.getRouteTaskExtendedTimelineItemTooltip(task, taskEtaWindow, undefined),
        content: isPoint ?
          this.bringozTimelineService.getRouteInternalItemContent(task) :
          (isBundle ?
            this.bringozTimelineService.getRouteBundleTaskTimelineItemContent(task, relations, false, index) :
            this.bringozTimelineService.getRouteTaskTimelineItemContent(task, relations, false, index)),
        style: style,
      }
    });
  }

  private _getColorByAgentId(id) {
    return this.commonsService.getColorById(id, this.colorPallet);
  }

  // private _getColorByAgentId(id) {
  //
  //   const agentIndex = _.findIndex(this.agents, (a: AgentModel) => {
  //     return a.id === id;
  //   })
  //
  //   if (agentIndex > -1) {
  //     return this.agents[agentIndex].displayColor || this.colorPallet[agentIndex];
  //   } else {
  //     const randomIndex = Math.floor(Math.random() * this.agents.length);
  //     return this.colorPallet[randomIndex];
  //   }
  // }

  private _schedulesToMoveTo(task) {
    const schedules = [];

    this.itemsDataSet.forEach((item) => {
      if (item.scheduleType === 'Availability' && _.isEqual(task.group, item.group)) {
        if (_.isEqual(this.moment(task.start).valueOf(), this.moment(item.start).valueOf()) ||
          this.moment(task.start).isBetween(this.moment(item.start), this.moment(item.end))
        ) {
          schedules.push(item)
        }
      }
    });
    return schedules;
  }

  private _getRouteByScheduleId(scheduleId) {
    return _.find(this.routes, (r) => {
      return r.planningResource.allocationInstanceId === scheduleId;
    });
  }

  private _getRoutesByResourceId(resourceId: string) {
    return _.filter(this.routes, (r) => {
      return r.resourceId === resourceId;
    });
  }

  private _getAgentsGroup(a: VisitScheduleResourceHolderExt, index) {
    const isEven = (index % 2) === 0;
    let className = 'group-row br-caption-2';
    className += !!isEven ? ' even' : ' odd';
    className += ' agent-left-container';

    return {
      id: a.id,
      agentId: a.holderId,
      holderId: a.holderId,
      name: a.agentReference?.fullName,
      nameInitials: this.$filter('userInitials')(a.agentReference),
      agentType: this.$filter('translate')(_.get(a, 'agentReference.agentType', '')),
      // skills: this._getTranslatedSkills(a.skills),
      tags: a.agentReference?.tags || ['TEST'],
      requiredSkills: a.skills,
      isExternal: a.isExternal,
      branchReferences: _.get(a, 'branchReferences'),
      // employmentType: this.$filter('translate')(a.employmentType),
      // priorityServiceAreasIds: _.get(a, 'agentPreferencesReference.priorityServiceAreas', []),
      // vehicleType: a.vehicleType,
      // status: a.status,
      className: className,
      // taskCount: _.get(a, 'itineraryInfo.numberOfTasks', 0),
      ref: a,
      order: index,
      showNested: true
    }
  }

  private _parseResourceToItem(resource: VisitScheduleResourceModel) {
    const color = this._getColorByAgentId(resource.agentId);
    const routes = this._getRoutesByResourceId(resource.id);

    const routeVisitScheduleDay = this.visitScheduleDays.find(vsd => vsd.id === resource.visitScheduleDayId);

    const isDisabled = resource.disabled || resource.scheduleArchived || (!!routes?.length && routes.every(r => r?.status === 'DISPATCHED')) || isVisitScheduleDayDispatched(routeVisitScheduleDay);
    const isArchived = resource.scheduleArchived;

    return {
      itemType: 'RESOURCE',
      scheduleType: resource.scheduleType,
      start: this.moment(resource.startTime),
      end: this.moment(resource.endTime),
      id: resource.id,
      // id: item.agentSchedule.id + ':Tag:' + item.agentId + ':Date:' + this.moment(item.agentSchedule.schedule.startTime).format("DD-MM-YYYY"),
      group: resource.resourceHolderId,
      agentId: resource.agentId,
      ref: resource,
      editable: {
        add: false,                          // add new items by double tapping
        updateTime: false,                   // drag items horizontally
        updateGroup: false,              // drag items from one group to another
        remove: false,                 // delete an item by tapping the delete button top right
        overrideItems: true          // allow these options to override item.editable
      },
      selectable: true,
      title: this._getShiftTimelineItemTooltip(resource),
      content: undefined,
      className: `schedule ${resource.scheduleType} ${isDisabled ? 'Disabled' : ''} ${isArchived ? 'Archived' : ''}`,
      // type: 'background',
      style: 'background: ' + color
    }
  }

  private _getScheduleBreakItemData(schedule, breakData, agentId, scheduleId) {
    const route = this._getRouteByScheduleId(schedule.id);
    return {
      // id: moment(date).valueOf() + '-' + item.agentSchedule.id, //AgentSchedule
      id: breakData.id + '-break',
      itemType: 'BREAK',
      start: this.moment(breakData.notBefore),
      end: this.moment(breakData.endDate ? breakData.endDate : (breakData.notBefore + breakData.duration)),
      startTime: breakData.notBefore,
      endTime: breakData.endDate,
      group: agentId,
      agentId: agentId,
      ref: breakData,
      scheduleId: scheduleId,
      editable: false,
      title: this.bringozTimelineService.getShiftTimelineItemTooltip(schedule, route),
      // content: this.bringozTimelineService.getShiftContentNew(item, dateFrom, dateTo, true),
      className: 'break',
      selectable: true
      // type: 'background'
    }
  }

  private _getShiftTimelineItemTooltip(schedule) {

    let skillsRow = '';
    if (!!schedule?.skills) {
      skillsRow = '<div class="info-row">'
        + this.$skillsIcon.outerHTML
        + '<span class="br-body-1 margin-right-10">' + this._getNames(schedule.skills) + '</span>'
        + '</div>'
    }

    let branchesRow = '';
    if (!!schedule?.branchReferences) {
      branchesRow = '<div class="info-row">'
        + this.$branchIcon.outerHTML
        + '<span class="br-body-1 margin-right-10">' + escapeHtml(this._getNames(_.map(schedule.branchReferences, 'name'), 3)) + '</span>'
        + '</div>'
    }

    return skillsRow
      + branchesRow
  }

  private _canAddToRoute(leftovers, toRouteId) {
    const route = _.find(this.routes, (r) => {
      return r.id === toRouteId;
    })
    let canAddBulk = true;
    _.forEach(leftovers, (l) => {
      const resourceSkills = _.get(route, 'resource.allocationSkills', []);
      const leftoverSkill = _.get(l, 'skills.length') ? l.skills[0] : (l.jobType === 'Operation' ? 'Merchandise' : 'Delivery');

      if (!_.includes(resourceSkills, leftoverSkill)) {
        const stopType = this.$filter('translate')('SKILLS.' + leftoverSkill);
        const routeType = this.$filter('translate')('SKILLS.' + resourceSkills[0]);
        // this.planningAlertsService.stopTypeToRouteRejectionInfo(stopType, routeType);
        canAddBulk = false;
        return false;
      }
    })
    return canAddBulk;
  }

  private _redrawRoutes(routes) {
    const activityItems = this._mapRoutesToActivityItems(routes);
    this._updateTimelineTasks(activityItems);
  }

  // private _redrawTasks(tasks) {
  //   const tasksCopy = angular.copy(tasks);
  //
  //   // Server Bugfixes
  //   _.forEach(tasksCopy, (t) => {
  //     if (t.packageList?.length) {
  //       if (t.packageList[0] && !t.packageList[0].items) {
  //         t.packageList[0] = {items: t.packageList[0]};
  //       }
  //     }
  //
  //     // t.routeId = r.id;
  //     const routeRef = _.find(this.routes, (r) => {
  //       return r.id === t.routeId;
  //     })
  //     if (!!routeRef) {
  //       t.agentId = routeRef.agentId;
  //     }
  //   })
  //
  //   const tasksItems = this._getTasksItemsData(tasksCopy);
  //   this._updateTimelineTasks(tasksItems);
  // }

  private _canItemMove(item) {

    const movingToRoute = _.find(this.routes, (r) => {
      return r.id === item.group;
    })

    if (item.activityType === 'GROUP' && item.stopIds.length < 1) {
      return false;
    }

    if (item.activityType !== 'GROUP' && !item.stopId) {
      return false;
    }

    if (movingToRoute) {
      const resourceSkills = _.get(movingToRoute, 'resource.allocationSkills', []);
      const itemSkill = item.purpose === 'Operation' ? 'Merchandise' : 'Delivery';
      if (!_.includes(resourceSkills, itemSkill)) {
        const stopType = this.$filter('translate')('SKILLS.' + itemSkill);
        const routeType = this.$filter('translate')('SKILLS.' + resourceSkills[0]);
        this.planningAlertsService.stopTypeToRouteRejectionInfo(stopType, routeType);
        return false;
      }
    }

    const orderedItems = _.filter(this.timeline.components[3].groups[item.group].orderedItems.byStart, (orderedItem) => {
      return !!orderedItem.data.activityType;
    });

    const itemPurpose = item.purpose;
    const itemIndex = _.findIndex(orderedItems, (orderedItem: any) => {
      return orderedItem.data.activityId === item.activityId;
    });

    const movedActivityOriginalRoute = _.find(this.routes, (r) => {
      const ids = _.map(r.activities, 'id');
      return _.includes(ids, item.id);
    })
    const activityOriginalIndex = _.findIndex(movedActivityOriginalRoute.activities, (a: any) => {
      return a.id === item.id;
    })

    if (_.isEqual(movedActivityOriginalRoute.id, item.group) &&
      _.isEqual(activityOriginalIndex, itemIndex)) {
      return false;
    }

    const parallelIndex = _.findIndex(orderedItems, (task: TaskModel) => {
      return (task.id !== item.id) && !!_.intersection(_.get(task, 'data.jobIds', []), _.get(item, 'jobIds', [])).length;
    });
    if (parallelIndex < 0) {
      return true;
    } else {
      return itemPurpose === 'Pickup' ? (itemIndex < parallelIndex) : (parallelIndex < itemIndex);
    }
  }

  private _getTimelineItemById(id) {

    if (!id) {
      return undefined;
    }

    const selectedItem = this.itemsDataSet.get({
      filter: (item) => {
        return item.id === id
      }
    });
    return this.itemsDataSet.get(selectedItem[0] ? selectedItem[0].id : undefined)
  }

  private _recalcDailyWorkingHours() {

    // Clear all itemType TOTAL
    const itemsToRemove = [];
    this.itemsDataSet.forEach((item) => {
      if (item.itemType === 'TOTAL') {
        itemsToRemove.push(item.id);
      }
    });
    this.itemsDataSet.remove(itemsToRemove);

    // Init Map By Date
    const routesByAgentByDateMap = {};
    this.routes?.forEach((r) => {
      const start = this.moment(r.activities[0]['eta']).startOf('day');
      const resourceHolderId = r.resource.resourceHolderId;
      if (!routesByAgentByDateMap[resourceHolderId]) {
        routesByAgentByDateMap[resourceHolderId] = {};
      }
      if (!routesByAgentByDateMap[resourceHolderId][start]) {
        routesByAgentByDateMap[resourceHolderId][start] = [];
      }
      routesByAgentByDateMap[resourceHolderId][start].push(r);
    })

    let backgroundTotalItems = [];
    _.forOwn(routesByAgentByDateMap, (datesMap, resourceHolderId) => {
      _.forOwn(datesMap, (routes, date) => {
        backgroundTotalItems = backgroundTotalItems.concat(this._getRouteTotalBackgroundItem(resourceHolderId, date, routes));
      })
    })
    // _.forOwn(routesByDateMap, (routes, date) => {
    //   backgroundTotalItems = backgroundTotalItems.concat(this._getRouteTotalBackgroundItem(date, routes));
    // })

    this.itemsDataSet.add(_.concat(backgroundTotalItems));
  }

  private _calcDurationMs(from: number, to: number): number {
    return Math.max(0, to - from);
  }

  private _formatDurationHHMM(durationMs: number): string {
    const safeMs = Math.max(0, durationMs);

    const totalMinutes = Math.floor(safeMs / 60000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  }

  private _getNames(names: string[], maxCount?: number) {
    let string = '';
    if (!names || !names.length) {
      return '';
    }

    let addedCount = 0;
    _.forEach(names, (name, i) => {
      addedCount += 1;
      string += name;
      if (i + 1 < names.length && i < (maxCount || 0)) {
        string += ', '
      }
    });

    if (!!maxCount && addedCount < names.length) {
      string += ` +${names.length - addedCount}`
    }
    return string;
  }

  $onDestroy() {
    this.bringozTimelineService.destroyCustomTooltip();
    window.removeEventListener("scroll", this._windowHideTooltips, true);
    window.removeEventListener("resize", this._windowHideTooltips, true);
    this._activeTooltipHides.slice().forEach((fn) => fn());
    this._activeTooltipHides = [];

    if (this.container) {
      this.container.removeEventListener('click', this._onContainerClick);
      this.container = null;
    }
    if (this.timeline) {
      this.timeline.destroy();
      this.timeline = null;
    }
    if (this.itemsDataSet) {
      this.itemsDataSet.clear();
      this.itemsDataSet = null;
    }
    if (this.groupsDataSet) {
      this.groupsDataSet.clear();
      this.groupsDataSet = null;
    }
  }


}

angular
  .module('bringoz.admin.scheduling-project')
  .component('visitScheduleTimeline', {
    bindings: {
      visitPlan: '<',
      page: '<',
      size: '<',
      totalElements: '<',
      agents: '<',
      resourcesUtilization: '<',
      resources: '<',
      routes: '<',
      tasks: '<',
      analysis: '<',
      serviceAreas: '<',
      totals: '<?',
      range: '<',
      query: '<',
      isLoading: '<',
      isSortMode: '<',
      isTooltipsEnabled: '<',
      isShowScheduleContentEnabled: '<',
      isHidden: '<?',
      isShowTaskColorByAgent: '<',
      isShowUtilization: '<',
      agentsGroup: '<',
      highlightedSchedules: '<?',
      highlightedTasks: '<?',
      isFavouriteAgentsMode: '<?',
      favouriteAgentIds: '<?',
      settings: '<?',
      agentColorMap: '<?',
      jobs: '<?',
      programTypeAliasMap: '<?',
      visitScheduleDays: '<?',
      onToggleMap: '&',
      onScheduleSelect: '&',
      onViewService: '&',
      onAxisClick: '&',
      onBreakRightClick: '&',
      onRightClickTask: '&',
      onRightClickSchedule: '&',
      onCreateSchedule: '&',
      onMoveGroup: '&',
      onMoveItem: '&',
      onTaskChange: '&',
      onDatesPageChange: '&',
      onAgentsGroupChange: '&',
      onToggleHighlightSchedule: '&',
      onHighlightedItemsChange: '&',
      onAgentColorClick: '&',
      onToggleIsFavouriteAgentsMode: '&',
      onToggleFavouriteAgent: '&',
      onResetFavouriteAgents: '&',
      onUpdateShift: '&',
      onPaginationChange: '&',
      onSettingsChange: '&',
      onDispatchDay: '&',
      onJobRightClick: '&',
      onInspectRouteClick: '&',
      onConflictIconClick: '&'
    },
    template: require('./visit-schedule-timeline.html').default,
    controller: VisitScheduleTimelineComponent
  });
